import React, { useEffect, useState, useRef, forwardRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Divider,
  IconButton,
  InputAdornment,
  Popover,
  Typography,
  // TextField,
  Drawer,
  Button,
  useMediaQuery,
} from "@mui/material";
import "../css/Contractor.css";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import CMilestoneList from "./CMilestoneList";
import { IoIosClose, IoMdClose } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { BarLoader } from "react-spinners";
import { NumericFormat } from "react-number-format";
import TextField from "@mui/material/TextField";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import ContractImg from "./../image/agreement.png";
import BellIcon from "../image/bell-icon.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Collapse } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Rack from "./../image/rack.png";

const initialChange = {
  status: "",
};

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        const rawValue = values.value;

        const formattedValue =
          Number(rawValue) % 1 === 0
            ? Number(rawValue).toFixed(0)
            : Number(rawValue).toFixed(2);

        onChange({
          target: {
            name: props.name,
            value: formattedValue,
          },
        });
      }}
      isAllowed={(values) => {
        const { floatValue, formattedValue } = values;
        if (floatValue === undefined) return true;

        // Ensure no more than 13 digits before decimal and 2 after
        const parts = formattedValue.replace(/[^\d.]/g, "").split(".");
        const beforeDecimal = parts[0] || "";
        const afterDecimal = parts[1] || "";

        return beforeDecimal.length <= 13 && afterDecimal.length <= 2;
      }}
      thousandSeparator
      valueIsNumericString
      allowNegative={false}
      prefix="$"
    />
  );
});
function ContractorHome() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState("");
  const [Changecontract, setChangeContract] = useState(false);
  const [milestoneList, setMilestoneList] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [reuplodaselectedPdf, setReuploadSelectedPdf] = useState(null);
  const [loader, setLoader] = useState(false);
  const [ownerinformation, setownerInformation] = useState(false);
  const [changeRequest, setChangeRequest] = useState(initialChange);
  const [projectList, setProjectList] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState({});
  const [milestoneListdata, setMilestoneListdata] = useState([]);
  const [projectname, setProjectname] = useState("");
  const [changeprojectname, setChangeProjectname] = useState("");
  const [projectid, setProjectid] = useState("");
  const [changeprojectid, setChangeProjectid] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [Notsigned, setNotSigned] = useState("");
  const [count, setCount] = useState({});
  const [ContractChangeRequest, setContractChangeRequest] = useState([]);
  const [genAI, setGenAI] = useState(false);
  const [state, setState] = useState({
    project_budget: "",
  });
  const [textAreaValues, setTextAreaValues] = useState([]);
  const [enableTextarea, setEnableTextarea] = useState(
    Array(ContractChangeRequest.length).fill(false)
  );
  const [editmilestone, setEditmilestone] = useState(false);
  const [Reuploadcontract, setReUplodacontract] = useState(false);
  const [filename, setFileName] = useState("");
  const [data, setData] = useState({});
  const [AImessage, setAImessage] = useState(false);
  const [inputList, setInputList] = useState([
    { Milestone: "", price: "", description: "" },
  ]);
  const [chatview, setChatView] = useState(false);
  const [messages, setMessages] = useState([]);
  const [sendcomment, setSendcomment] = useState("");
  const [disabled, setDisabled] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [milestonechangeRequestchat, setMilestonechangeRequestchat] = useState(
    []
  );
  const [milestoneStates, setMilestoneStates] = useState({});
  const [Nochat, setNoChat] = useState(false);
  const [values, setValues] = useState({
    numberformat: "",
  });
  const [isContractLoader, setIsContractLoader] = useState(false);

  const isMobile = useMediaQuery("(max-width:768px)");

  const location = useLocation();
  const { notification } = location.state || {};

  const projectBudgetRef = useRef(null);
  const revisedAmountRef = useRef(null);
  const [shouldFocus, setShouldFocus] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [popupWindow, setPopupWindow] = useState(null);
  const [individualMileStone, setIndividualMileStone] = useState(null);
  const [isToggled, setIsToggled] = useState(false);
  const [projectLevelModal, setProjectLevelModal] = useState(false);
  const [ProjectLevelViewModal, setProjectLevelViewModal] = useState(false);
  const [projectLevelContractorFiles, setProjectLevelContractorFiles] =
    useState([]);
  const [fileError, setFileError] = useState("");
  const [openSections, setOpenSections] = useState({});
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [ContractPdf, setContractPdf] = useState(false);
  const [showDocuments, setShowDocuments] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [mileDocs, setMileDocs] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [docHeader, setDocHeader] = useState("");
  const [loaderMsg, setLoaderMsg] = useState("Fetching records...");

  //File modal view
  const [selectedContractDoc, setSelectedContractDoc] = useState(null);
  const [ContractDocuments, setContractDocuments] = useState(false);

  //projectStatus
  const [isProjectStatusMatch, setIsProjectStatusMatch] = useState(false);
  const [notificationData, setNotificationData] = useState(null);
  const [cancelToken, setCancelToken] = useState(null);

  const toggleExpand = (msgIndex) => {
    setExpanded((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };
  const handleToggleView = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the specific section's open/closed state
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!notification) return;

      setEditIndex(null);
      setIndividualMileStone(null);
      setNotificationData(notification);

      try {
        const response = await axios.get("/cvault/get-project-detail/");
        const pData = response?.data?.data?.map((project, index) => ({
          ...project,
          id: index + 1,
        }));

        const projectData = pData?.find(
          (item) => item.project_id === notification.project_id
        );

        if (!projectData) return;

        const milestoneId = {
          project_id: notification?.project_id,
          milestone_id: notification?.milestone_id,
        };
        const responses = await axios.post(
          "/cvault/milestone-details/",
          milestoneId,
          {
            headers: headers,
          }
        );

        const milestoneData = responses?.data?.data || [];
        const index = milestoneData.findIndex(
          (item) => item.id === notification?.milestone_id
        );
        const miledata = milestoneData.filter(
          (item) => item.id === notification?.milestone_id
        );

        if (projectData.status === notification.project_status) {
          setChangeProjectid(notification.project_id);
          setChangeProjectname(notification.project_name);

          if (
            projectData?.status === "Not Started" &&
            (projectData?.change_request?.status === "Review" ||
              projectData?.change_request?.status === "" ||
              projectData?.change_request?.status !== "Owner Review")
          ) {
            getPdfFile(notification.project_id);
            setChangeRequest(initialChange);
            setChangeContract(true);
            MilestonechangeRequest(notification.project_id);
            // setIndividualMileStone(null);
            // setEditIndex(null);
          } else if (projectData?.status === "In Progress") {
            handleMilestone(notification.project_id, notification.project_name);
            MilestonechangeRequest(notification.project_id, miledata[0]);
            handleMilestoneModal(notification.project_id);
          }
        } else {
          console.log("not matches");
          // toast.warning(`Project Moved to ${projectData.status} state`);
          // toast.warning(`No action required`);
        }
      } catch (error) {
        console.error("Error fetching project details:", error);
      }

      navigate(location.pathname, { replace: true, state: null });
    };

    fetchData();
  }, [notification]);

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  useEffect(() => {
    setLoaderMsg("Fetching records...");
    getProjectlist();
  }, []);

  useEffect(() => {
    if (selectedProject !== "") {
      setTimeout(() => {
        const targetElement = document.getElementById("expandOfProjects");

        if (targetElement) {
          targetElement.scrollIntoView({ block: "center", behavior: "smooth" });
          targetElement.style.scrollMarginTop = "100px";
        }
      }, 500);
    }
  }, [selectedProject]);

  useEffect(() => {
    checkScroll();
  }, [openSections]);
  const containerRef = useRef(null);
  const leftBtnRef = useRef(null);
  const rightBtnRef = useRef(null);

  const checkScroll = () => {
    if (!containerRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;

    // Hide left button if at the start
    if (scrollLeft === 0) {
      if (leftBtnRef?.current?.style) {
        leftBtnRef.current.style.display = "none";
      }
    } else {
      if (leftBtnRef?.current?.style)
        leftBtnRef.current.style.display = "block";
    }

    // Hide right button if at the end
    if (scrollLeft + clientWidth >= scrollWidth - 1) {
      if (rightBtnRef?.current?.style)
        rightBtnRef.current.style.display = "none";
    } else {
      if (rightBtnRef?.current?.style)
        rightBtnRef.current.style.display = "block";
    }
  };

  const handleScrollLeft = (index) => {
    const fileContainer = document.getElementById(`scroll-container-${index}`);
    if (fileContainer) {
      fileContainer.scrollLeft -= 100; // Adjust the scroll amount as needed
    }
  };

  const handleScrollRight = (index) => {
    const fileContainer = document.getElementById(`scroll-container-${index}`);
    if (fileContainer) {
      fileContainer.scrollLeft += 100; // Adjust the scroll amount as needed
    }
  };

  const handleNoChangeToggle = (index) => {
    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) =>
        i === index
          ? { ...milestone, noChange: !milestone.noChange }
          : milestone
      )
    );
  };

  const handleIncreaseChange = (index, value) => {
    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) =>
        i === index ? { ...milestone, increase: value } : milestone
      )
    );
  };

  const milestoneInputChange = (e, index, field, amount_status) => {
    let updatedContractChangeRequest = [...ContractChangeRequest];
    let value = e.target.value; // Allow only numbers and decimals

    let revisedAmount =
      parseFloat(
        (typeof value === "number" ? value.toString() : value || "0").replace(
          /[^0-9.]/g,
          ""
        )
      ) || 0;
    let originalAmount =
      parseFloat(
        (typeof changeRequestData[editIndex || 0]?.price === "number"
          ? changeRequestData[editIndex || 0]?.price.toString()
          : changeRequestData[editIndex || 0]?.price || "0"
        ).replace(/[^0-9.]/g, "")
      ) || 0;

    let amountStatus = amount_status;

    // Handle the logic for when 'revised_amount' field is changed
    if (field === "revised_amount") {
      let difference = revisedAmount - originalAmount;

      updatedContractChangeRequest[index] = {
        ...updatedContractChangeRequest[index],
        amount_status: amountStatus,
        revised_amount: revisedAmount,
        error:
          revisedAmount <= 0
            ? "Amount is required"
            : amount_status === "Decrease" && revisedAmount > originalAmount
            ? "The decrease amount cannot exceed the milestone amount"
            : "",
      };
    }
    setContractChangeRequest((prevState) =>
      prevState.map(
        (milestone, i) =>
          i === index
            ? {
                ...milestone,
                [field]: value, // Update the specific field

                amount_status:
                  updatedContractChangeRequest[index].amount_status,
                revised_amount:
                  updatedContractChangeRequest[index].revised_amount,
                error: updatedContractChangeRequest[index].error,
                milestone_amount:
                  updatedContractChangeRequest[index].milestone_amount,
              }
            : milestone // Otherwise, return the original milestone
      )
    );
  };

  const handleAmountStatusChange = (index, value) => {
    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) => {
        if (i !== index) return milestone; // Return unchanged items

        let revisedAmount = parseFloat(milestone.revised_amount) || 0;
        let originalAmount =
          parseFloat(
            (typeof milestone.milestone_amount === "number"
              ? milestone.milestone_amount.toString()
              : milestone.milestone_amount || "0"
            ).replace(/,/g, "")
          ) || 0;

        return {
          ...milestone,
          amount_status: value,
          error:
            revisedAmount <= 0
              ? "Amount is required"
              : value === "Decrease" && revisedAmount > originalAmount
              ? "Decrease amount must not be less than the milestone amount."
              : "",
          revised_amount: value === "noChange" ? 0 : revisedAmount,
          milestone_amount: originalAmount,
        };
      })
    );
  };

  const handleBlur = (e, index, field, amount_status) => {
    let updatedContractChangeRequest = [...ContractChangeRequest];
    let value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers and decimals
    let revisedAmount = parseFloat(value) || 0;
    let originalAmount =
      parseFloat(
        updatedContractChangeRequest[index].milestone_amount.replace(/,/g, "")
      ) || 0;

    if (
      amount_status === "Increase" &&
      (!revisedAmount || revisedAmount <= 0)
    ) {
      setContractChangeRequest((prev) => ({
        ...prev,
        error: "Amount is required when increasing.",
      }));
      return;
    }

    if (
      amount_status === "Decrease" &&
      parseFloat(revisedAmount) >= originalAmount
    ) {
      setContractChangeRequest((prev) => ({
        ...prev,
        error: "Decrease amount must be less than the milestone amount.",
      }));
      return;
    }
  };

  const cancelCRRequest = async (mile) => {
    setLoader(true);

    try {
      const payload = {
        project_id: individualMileStone?.row?.project || changeprojectid,
        milestone_id: mile?.id || individualMileStone?.row?.id,
      };
      const response = await axios.post(
        "/cvault/cancel-change-request/",
        payload,
        {
          headers: headers,
        }
      );
      if (individualMileStone === null) {
        toast.success(
          `Change Request denied for Milestone(${
            mile?.milestone_number || !editIndex ? editIndex + 1 : 1 || 1
          })`
        );

        MilestonechangeRequest(
          changeprojectid,
          individualMileStone !== null ? individualMileStone : null
        );
        handlegetchat(mile);
      } else {
        toast.success(
          `Change Request denied for Milestone(${
            individualMileStone?.row?.milestone_number || 1
          })`
        );
        setChangeContract(false);
      }

      handleMilestoneModal(changeprojectid);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setChangeContract(false);
      // toast.success("Change Request Cancelled");
    }
  };

  const handleFileUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024; // 200MB limit
    const allowedTypes = ["image", "video", "application/pdf", "text/plain"];

    let currentTotalSize = projectLevelContractorFiles.reduce(
      (acc, file) => acc + file.file.size,
      0
    );
    let validFiles = [];

    for (let file of selectedFiles) {
      if (projectLevelContractorFiles.some((f) => f.name === file.name)) {
        // toast.warning(`File ${file.name} is already included.`);
        setFileError(`File ${file.name} is already included.`);

        continue;
      }

      if (!allowedTypes.some((type) => file.type.startsWith(type))) {
        // toast.warning(`File type not supported: ${file.name}`);
        setFileError(`File type not supported: ${file.name}`);
        continue;
      }

      if (currentTotalSize + file.size > maxTotalSize) {
        // toast.warning(
        //   `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        // );
        setFileError(
          `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        );
        break;
      }

      validFiles.push(file);
      currentTotalSize += file.size;
    }

    const newFiles = validFiles.map((file) => ({
      file,
      name: file.name,
      blob: new Blob([file], { type: file.type }),
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : file.type === "application/pdf"
        ? "pdf"
        : "text",
    }));

    setProjectLevelContractorFiles((prevFiles) => [...prevFiles, ...newFiles]);
    e.target.value = "";
  };

  const handleFileUploadChangeRequest = (e, index) => {
    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024; // 200MB limit
    // const allowedTypes = ["image", "video", "application/pdf", "text/plain"];

    let currentTotalSize = ContractChangeRequest[index || 0]?.files.reduce(
      (acc, file) => acc + file.file.size,
      0
    );
    let validFiles = [];

    for (let file of selectedFiles) {
      if (
        ContractChangeRequest[index || 0]?.files.some(
          (f) => f.name === file.name
        )
      ) {
        // toast.warning(`File ${file.name} is already included.`);
        setFileError(`File ${file.name} is already included.`);
        continue;
      }

      // if (!allowedTypes.some((type) => file.type.startsWith(type))) {
      //   // toast.warning(`File type not supported: ${file.name}`);
      //   setFileError(`File type not supported: ${file.name}`);

      //   continue;
      // }

      const inputElement = document.getElementById("chatInput");
      if (inputElement) {
        inputElement.focus();
      }
      if (currentTotalSize + file.size > maxTotalSize) {
        // toast.warning(
        //   `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        // );
        setFileError(
          `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        );
        break;
      }

      validFiles.push(file);
      currentTotalSize += file.size;
    }

    const newFiles = validFiles.map((file) => ({
      file,
      name: file.name,
      blob: new Blob([file], { type: file.type }),
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : file.type === "application/pdf"
        ? "pdf"
        : file.type === "text/plain"
        ? "text"
        : "others",
    }));

    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) => {
        if (i !== index) return milestone; // Return unchanged items

        return {
          ...milestone,
          files: milestone.files ? [...milestone.files, ...newFiles] : newFiles,
        };
      })
    );
    e.target.value = "";
  };
  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (projectLevelContractorFiles.length === 0) {
      toast.warning("No files to upload!");
      return;
    }

    const formData = new FormData();

    projectLevelContractorFiles.forEach((item, index) => {
      formData.append("files", item.file);
    });

    try {
      const response = await fetch("YOUR_API_ENDPOINT", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        toast.success("Files uploaded successfully!");
        setProjectLevelContractorFiles([]); // Clear files after upload
        setProjectLevelModal(false);
      } else {
        toast.error("File upload failed.");
      }
    } catch (error) {
      toast.error("Error uploading files.");
    }
  };

  const handleDelete = (fileIndex, editI) => {
    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) => {
        if (i !== editI) return milestone; // If not the editIndex, return the milestone unchanged

        // Remove the file from the 'files' array at the specified index
        const updatedFiles = milestone?.files.filter(
          (_, index) => index !== fileIndex
        );

        return {
          ...milestone,
          files: updatedFiles, // Update the files list
        };
      })
    );
  };
  const controllerRef = useRef(null); // Store AbortController instance

  const viewFiles = async (file, iframeShow = false) => {
    setFileError("");
    iframeShow && setShowDocuments(null);

    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });
      setLoader(false);
      setIsLoader(false);

      const downfunc = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();
        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // ✅ Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // ✅ Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // ✅ Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // ✅ Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };
      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data);
          } else {
            downfunc(response);
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            setContractDocuments(true);
            setSelectedContractDoc(response.data.base64_content);
          } else {
            downfunc(response);
          }
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setLoader(false);
        setFileError("");
      } else {
        // toast.error(error?.response?.data?.error || "Unable to fetch file.");
        setLoader(false);
        setIsLoader(false);
        setShowDocuments(null);
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
      }
    }
  };

  const modelStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    // p: 2,
    maxHeight: "100vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
    width: "100%",
    margin: "auto",
  };

  const iframeStyle = {
    width: "100%",
    height: "-webkit-fill-available",
    border: "none",
  };

  const iframeStyleContractPdf = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "50%",
  };

  const Reupload = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    padding: "0px 16px 16px 16px",
    width: "85%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  var popoverStyle = {
    border: " 0px solid rgba(0, 0, 0, .2)",
    borderRadius: "2px",
    fontFamily: "Roboto,sans-serif",
    boxShadow: " 0 2px 10px rgba(0, 0, 0, .2)",
    padding: "5px 15px 10px 15px",
    lineHeight: " 24px",
    fontSize: "14px",
    width: "200px",
    height: "23vh",
    background: "white",
    opacity: "0.9",
  };

  const getProjectlist = async () => {
    setLoaderMsg("Fetching records...");
    try {
      var pData = await axios.get("/cvault/get-project-detail/");
      pData = pData?.data?.data?.map((project, index) => {
        return { ...project, id: index + 1 };
      });
      const projectData = pData?.filter(
        (item) => item.project_id === notification?.project_id
      );

      if (notification) {
        setSelectedProject(projectData);
      }

      setProjectList(pData);
      setTimeout(() => {
        setLoaderMsg("No projects found");
      }, 100);
    } catch (error) {
      setLoaderMsg("No projects found");

      toast.error(
        "Unable to retrieve project details. Please try again later."
      );
    }
  };

  const columns = [
    { field: "id", headerName: "S.No", flex: 1, minWidth: 60, maxWidth: 80 },
    {
      headerName: "Project Name",
      field: "project_name",
      sortable: false,
      flex: 2,
      minWidth: 200,
      renderCell: (params) => <div>{params?.row?.name}</div>,
    },
    {
      field: "contractor_payout",
      headerName: "Total Payout",
      flex: 0.5,
      minWidth: 150,
      renderCell: (params) =>
        params?.row?.contractor_payout ? (
          <div className="MuiDataGrid-cellContent m-3">
            {params?.row?.contractor_payout}
          </div>
        ) : (
          <div className="MuiDataGrid-cellContent ms-3">-</div>
        ),
    },
    {
      field: "budget",
      headerName: "Total Contract Value",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div className="MuiDataGrid-cellContent ms-2">
          {params?.row?.budget}
        </div>
      ),
    },
    {
      field: "owner_name",
      headerName: "Owner",
      flex: 1,
      minWidth: 100,
      // maxWidth:120,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={() => {
            ownerinfo(params?.row);
          }}
        >
          {params?.row?.details?.owner_name}
        </div>
      ),
    },
    {
      headerName: "Documents",
      field: "project_files",
      sortable: false,
      flex: 1,
      minWidth: 70,
      maxWidth: 140,
      renderCell: (params) => (
        <div className="d-flex align -items-center justify-content-between">
          <Tooltip title="View Project Contract" placement="bottom">
            <div
              class="icon"
              style={{ color: "#F5AE41", cursor: "pointer" }}
              onClick={() => {
                getContractPdfFile(params?.row?.project_id);
              }}
            >
              <img
                src={ContractImg}
                alt="contract"
                style={{ width: "30px", height: "30px", objectFit: "cover" }}
              />
            </div>
          </Tooltip>
          <Tooltip
            title={
              params?.row?.additional_files?.length
                ? "View Project Documents"
                : "No Documents to view"
            }
            placement="bottom"
          >
            <div
              class="icon"
              style={{
                color: "#F5AE41",
                marginLeft: "20px",
                cursor: params?.row?.additional_files?.length ? "pointer" : "",
              }}
              onClick={() => {
                if (params?.row?.additional_files?.length) {
                  setChangeProjectname(params?.row?.name);
                  setDocHeader(`${params?.row?.name} - Project Documents`);

                  setProjectLevelContractorFiles(
                    params?.row?.additional_files || []
                  );
                  setProjectLevelViewModal(true);
                }
                setFileError("");
              }}
            >
              <img
                src={Rack}
                style={{
                  width: "30px",
                  height: "30px",
                  objectFit: "cover",
                  opacity: params?.row?.additional_files?.length ? 1 : 0.5,
                }}
                alt="project documents"
              />
            </div>
          </Tooltip>
        </div>
      ),
    },

    {
      headerName: "Milestones",
      field: "action",
      sortable: false,
      flex: 1,
      // minWidth: 100,
      maxWidth: 100,
      renderCell: (params) => (
        <button
          className="btn detail-btn ms-2"
          onClick={() => {
            setChangeProjectid(params?.row?.project_id);
            setChangeProjectname(params?.row?.name);
            setSelectedProject(params?.row);
            handleMilestone(
              params?.row?.project_id,
              params?.row?.name,
              params?.row
            );
          }}
          style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
        >
          View
        </button>
      ),
    },

    {
      field: "change_request",
      headerName: "Project Status",
      sortable: false,
      flex: 2,
      minWidth: 150,
      maxWidth: 150,
      renderCell: (params) =>
        params?.row?.status === "Not Started" &&
        params?.row?.change_request?.status === "Review" &&
        params?.row?.change_request?.status !== "Owner Review" ? (
          <button
            className="btn detail-btn"
            onClick={() => {
              setEditIndex(null);

              setChangeRequest(initialChange);
              // setChangeContract(true);
              MilestonechangeRequest(params?.row?.project_id);
              setChangeProjectname(params?.row?.name);
              setChangeProjectid(params?.row?.project_id);
              setIndividualMileStone(null);
              getPdfFile(params?.row?.project_id);
            }}
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          >
            Review
          </button>
        ) : params?.row?.status === "Not Started" &&
          params?.row?.change_request?.status !== "Owner Review" ? (
          <button
            className="btn detail-btn"
            onClick={() => {
              setEditIndex(null);

              setChangeProjectid(params?.row?.project_id);
              // setChangeContract(true);
              MilestonechangeRequest(params?.row?.project_id);
              setChangeProjectname(params?.row?.name);
              setIndividualMileStone(null);
              getPdfFile(params?.row?.project_id);
            }}
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          >
            Change
          </button>
        ) : (
          <>
            <div style={{ fontSize: "14px", fontWeight: "500", color: "gray" }}>
              {params?.row?.status === "Not Started"
                ? params?.row?.change_request?.status
                : params?.row?.status === "Payment Initiated"
                ? "Admin Review"
                : params?.row?.status === "Awaiting Payment"
                ? "Admin Review"
                : params?.row?.status === "In Progress"
                ? "Execution Phase"
                : params?.row?.status}
            </div>
          </>
        ),
    },
    {
      field: "change",
      headerName: "",
      sortable: false,
      flex: 0.2,
      minWidth: 40,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={(e) => {
            setCount(params?.row?.milestone_status_count);
            handleClick(e);
          }}
        >
          <BsThreeDotsVertical />
        </div>
      ),
    },
  ];

  const headerClassName = "custom-header";

  const getPdfFile = async (id) => {
    setIsContractLoader(true);
    try {
      const data = {
        project: id,
      };
      const response = await axios.post("/cvault/get-pdf/", data, {
        headers: headers,
      });
      setChangeContract(true);

      setSelectedPdfFile(response?.data?.base64_content || null);
      setIsContractLoader(false);
    } catch (error) {
      setSelectedPdfFile(null);
      setChangeContract(true);

      setIsContractLoader(false);
    }
  };

  const getContractPdfFile = async (id) => {
    setLoader(true);
    try {
      const data = {
        project: id,
      };
      const response = await axios.post("/cvault/get-pdf/", data, {
        headers: headers,
      });

      setLoader(false);
      setContractPdf(true);
      setSelectedPdfFile(response?.data?.base64_content);
    } catch (error) {
      setLoader(false);
      setSelectedPdfFile(null);
      toast.error(
        error?.response?.data?.error || "Unable to fetch the contract file."
      );
    }
  };

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };
  const changeRequestData = ContractChangeRequest?.map((milestone, index) => ({
    milestone: milestone.id,
    milestone_name: milestone.milestone,
    description: milestone.milestone_description,
    price: milestone.milestone_amount,
    comment: textAreaValues[index] || newMessage,
    revised_amount:
      milestone?.amount_status !== "noChange"
        ? milestone?.revised_amount || 0
        : null,
    amount_status:
      milestone?.amount_status !== "noChange" ? milestone.amount_status : null,
    files: milestone?.files?.map((v) => v.file),
  }));

  const MilestonechangeRequest = async (id, mile = null) => {
    // setEditIndex(null);
    setLoader(true);
    try {
      const milestoneId = { project_id: id };

      if (mile) {
        milestoneId.milestone_id = mile?.id || mile?.milestone_id;
        setInputList([
          {
            price: mile?.milestone_amount,
            Milestone: mile?.milestone,
            description: mile?.description,
          },
        ]);
      }

      const response = await axios.post(
        "/cvault/milestone-details/",
        milestoneId,
        {
          headers: headers,
        }
      );

      const pData = response?.data?.data || [];
      let milestoneNumber = mile?.row?.milestone_number || 1;

      if (notification) {
        const index = pData.findIndex(
          (item) => item.id === notification?.milestone_id
        );

        const miledata = pData.filter(
          (item) => item.id === notification?.milestone_id
        );
        const miledetails = await axios.get(
          `/cvault/get-milestones/?project_id=${notification?.project_id}`
        );

        const milefilterData = miledetails?.data?.data.filter(
          (item) => item.id === notification?.milestone_id
        );
        const mileIndex = pData.findIndex(
          (item) => item.id === notification?.milestone_id
        );

        if (index !== -1) {
          if (notification?.project_status === "In Progress") {
            let projResponse = await axios.get("/cvault/get-project-detail/");
            let projList = projResponse?.data?.data || [];

            projList = projList.map((project, index) => ({
              ...project,
              id: index + 1,
            }));

            const projectData = projList.find(
              (item) => item.project_id === notification?.project_id
            );

            if (projectData) {
              setSelectedProject(projectData);
            }

            if (milefilterData?.[0]) {
              if (
                // milefilterData[0]?.status !== "Completed" &&
                // milefilterData[0]?.status !== "Inspection Request" &&
                // milefilterData[0]?.status !== "Inspection Initiated" &&
                // milefilterData[0]?.status !== "Inspection Completed"
                milefilterData[0]?.status === "In Progress" ||
                milefilterData[0]?.status === "Not Started" ||
                milefilterData[0]?.status === "Initial Payment" ||
                milefilterData[0]?.status === "CR Phase"
              ) {
                if (
                  milefilterData[0]?.status !== "In Progress" &&
                  (milefilterData[0]?.change_request_status?.status === "" ||
                    milefilterData[0]?.change_request_status?.status ===
                      "Contractor Review" ||
                    milefilterData[0]?.change_request_status?.status ===
                      "Review")
                ) {
                  setChangeContract(true);
                } else {
                  milefilterData[0]?.status !== "In Progress" &&
                    // toast.warning(`No action required`);
                    toast.warning(`Action already taken`);
                  setIndividualMileStone(null);
                  setEditIndex(null);
                }
              } else {
              }
            }

            if (miledata?.[0]) {
              setIndividualMileStone({ id: miledata[0]?.id, row: miledata[0] });
              setInputList([
                {
                  price: miledata[0]?.milestone_amount,
                  Milestone: miledata[0]?.milestone,
                  description: miledata[0]?.description,
                },
              ]);
              setEditIndex(mileIndex);

              handlegetchat(miledata[0], notification?.project_id);
            }
          } else {
            setEditIndex(mileIndex);
            handlegetchat(miledata?.[0], notification?.project_id);
          }
          if (milefilterData[0]?.milestone_number) {
            milestoneNumber = milefilterData[0]?.milestone_number;
          }
        }
      }

      setLoader(false);
      setDisabled(response?.data?.status);

      setContractChangeRequest(
        pData.map((val, idx) => ({
          ...val,
          milestone_number: milestoneNumber || idx + 1,
          revised_amount: val?.revised_amount || 0,
          amount_status: val?.amount_status || "noChange",
          milestone_amount: val?.milestone_amount,
          files: [],
        }))
      );
    } catch (error) {
      setLoader(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "phone") {
      if (value.length <= 10) {
        setState((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === "zip") {
      if (value.length <= 5) {
        setState((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      const sanitizedValue =
        name === "month" || name === "date"
          ? Math.max(0, parseInt(value, 10))
          : value;
      setState((prev) => ({ ...prev, [name]: sanitizedValue }));
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setSelectedPdf(file);
    setFileName(file?.name);
    milestonepdfs(file);
    setAImessage(true);
    milestonepdf(file);
  };

  const milestonepdf = async (file) => {
    setLoader(true);
    if (genAI) {
      try {
        const formData = new FormData();
        formData.set("pdf", file);

        const response = await axios.post(
          "/cvault/pdf-milestone-parser/",
          formData,
          {
            headers: headers,
          }
        );

        setData(response.data);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.error("Error submitting form:", error);
        if (
          error?.response?.data?.message
            .toLowerCase()
            .includes("you exceeded your current quota")
        ) {
          toast.error(
            "The AI function is currently not accessible, please update all the milestone details manually"
          );
        } else {
          toast.error(
            "Unable to fetch the required Milestone Information from the uploaded Contract. Please update all the required Milestone details manually"
          );
        }
      }
    } else {
      setLoader(false);
      if (individualMileStone === null) {
        setInputList([
          { Milestone: "", price: "", description: "" },
          { Milestone: "", price: "", description: "" },
          { Milestone: "", price: "", description: "" },
        ]);
      } else {
        setInputList([
          {
            Milestone: individualMileStone?.row?.milestone,
            price: individualMileStone?.row?.milestone_amount,
            description: individualMileStone?.row?.milestone_description,
          },
        ]);
        setState((prevState) => ({
          ...prevState,
          project_budget:
            selectedProject?.budget.replace("$", "").replace(",", "") || "",
        }));
      }
      toast.warning(
        "Uploaded Contract opened in Viewer. Please update all the required Milestone details manually"
      );
    }
  };

  const getGenAI = async () => {
    try {
      var pData = await axios.get("/cvault/genai-status/");
      setGenAI(pData?.data?.genai_status);
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  useEffect(() => {
    if (data && data?.length === 0) {
      setInputList([
        { price: "", Milestone: "", description: "" },
        { price: "", Milestone: "", description: "" },
        { price: "", Milestone: "", description: "" },
      ]);
    } else if (data && data?.data && data?.data.length !== 0) {
      setInputList(
        data?.data?.map((item) => ({
          price: item.price,
          Milestone: item.milestone,
          description: item?.description,
        }))
      );
    }
  }, [data]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const ownerinfo = (row) => {
    setSelectedOwner(row);
    setownerInformation(true);
  };

  const handleMilestoneModal = async (id) => {
    setLoaderMsg("Fetching records...");
    setProjectid(id);
    try {
      const milestonedata = await axios.get(
        `/cvault/get-milestones/?project_id=${id}`
      );
      setMilestoneListdata(milestonedata?.data?.data);
      setTimeout(() => {
        setLoaderMsg("No milestones found");
      }, 100);
      setNotSigned(milestonedata?.data?.project_status);
      getProjectlist();
    } catch (error) {
      setLoaderMsg("No milestones found");
    }
  };

  const handlegetchat = async (milestone, prj = null) => {
    setMilestonechangeRequestchat(milestone);
    setMessages([]);
    setNewMessage("");
    setSendcomment("");
    setNoChat(false);
    const data = {
      project_id: prj || changeprojectid,
      milestone_id: milestone?.id,
    };

    try {
      const response = await axios.post("/cvault/change-request-chat/", data, {
        headers: headers,
      });
      if (
        Array.isArray(response?.data?.data) &&
        response?.data?.data?.length === 0
      ) {
        setSendcomment(response?.data.status);
        setNoChat(true);
      } else {
        setSendcomment(response?.data.status);
        setMessages(response?.data?.data);
      }
      // setMessages(response?.data?.data);
      setChatView(true);
    } catch (error) {
      toast.error("Unable to retrieve chat details. Please try again later.");
    }
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === "") {
      return;
    }
    setMessages([
      ...messages,
      {
        chat: newMessage,
        user: "Contractor",
        files: ContractChangeRequest[editIndex || 0]?.files,
      },
    ]);
    setNoChat(false);
    setNewMessage("");
  };

  const sendchat = async () => {
    if (newMessage?.length > 0) {
      setLoader(true);
      const data = {
        project_id: changeprojectid,
        milestone_id: milestonechangeRequestchat?.id,
        comment: newMessage,
        revised_amount:
          ContractChangeRequest[editIndex || 0]?.amount_status !== "noChange"
            ? ContractChangeRequest[editIndex || 0]?.revised_amount || 0
            : null,
        amount_status:
          ContractChangeRequest[editIndex || 0]?.amount_status !== "noChange"
            ? ContractChangeRequest[editIndex || 0]?.amount_status
            : null,
      };

      // Create FormData object
      const formData = new FormData();

      // Append each field in the data object to FormData
      for (const key in data) {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
      if (ContractChangeRequest[editIndex || 0]?.files?.length > 0) {
        ContractChangeRequest[editIndex || 0]?.files.forEach((file) => {
          formData.append("files", file.file);
        });
      }

      try {
        const response = await axios.post(
          "/cvault/change-request-temp-chat/",
          formData,
          {
            headers: headers,
          }
        );
        handleSendMessage();
        setSendcomment(true);
        setLoader(false);
        MilestonechangeRequest(
          changeprojectid,
          individualMileStone !== null ? individualMileStone : null
        );
      } catch (error) {
        setLoader(false);

        if (error?.response?.data?.error?.includes("already")) {
          setFileError(error?.response?.data?.error);
        } else {
          setFileError("Unable to send the message. Please try again later.");
        }
      }
    }
  };

  const Reuploadfeedback = async () => {
    setLoader(true);
    try {
      const data = {
        changeRequestData:
          individualMileStone !== null
            ? changeRequestData[0]
            : changeRequestData,
        project: changeprojectid,
      };

      if (individualMileStone !== null) {
        data.milestone_id = individualMileStone.id;
        // data.files = changeRequestData[0]?.files
      }

      // Create FormData object
      const formData = new FormData();

      // Append each field in the data object to FormData
      for (const key in data) {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
      formData.append(
        "changeRequestData",
        JSON.stringify(data.changeRequestData)
      );

      if (changeRequestData[0]?.files?.length > 0) {
        for (let i = 0; i < changeRequestData[0].files.length; i++) {
          const file = changeRequestData[0].files[i];
          // Append the actual binary file to the FormData object
          if (file instanceof File) {
            formData.append(`files`, file);
          }
        }
      }

      let api = "";
      if (individualMileStone === null) {
        api = "/cvault/project-change-request/";
      } else {
        api = "/cvault/milestone-change-request/";
      }

      const response = await axios.post(
        api,
        individualMileStone === null ? data : formData,
        {
          headers: headers,
        }
      );
      setLoader(false);
      if (individualMileStone !== null) {
        setChatView(false);
        toast.success(
          `Change Request for Milestone (${
            individualMileStone?.row?.milestone_number || 1
          }) sent to Owner`
        );
      } else {
        toast.success(`Change Request(s) sent to Owner`);
      }
      handleSendMessage();

      getProjectlist();
      if (individualMileStone !== null) {
        handleMilestoneModal(projectid);
      }
      setChangeContract(false);
      setSelectedPdf(null);
      // setChangeProjectid("");
      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
    } catch (error) {
      setLoader(false);
      // setChangeProjectid("");
      // setChangeContract(false);
      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
      setSelectedPdf(null);
      // toast.error("Error submitting form. Please try again later.");
      if (error?.response?.data?.error?.includes("already")) {
        setFileError(error?.response?.data?.error);
      } else {
        setFileError(
          "Unable to process the change request. Please try again later"
        );
      }
    }
  };

  const handleMilestone = (id, name, row) => {
    setProjectname(name);
    handleMilestoneModal(id);
    setMilestoneList(id);
  };

  const handleInputChange = (e, index, field) => {
    const updatedContractChangeRequest = [...ContractChangeRequest];
    updatedContractChangeRequest[index][field] = e.target.value;
    setContractChangeRequest(updatedContractChangeRequest);
  };

  const milestonepdfs = (file) => {
    const pdfUrl = URL.createObjectURL(file);
    setReuploadSelectedPdf(pdfUrl);
  };

  const handleInputChanges = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { price: "", Milestone: "" }]);
  };

  const Acceptproject = async () => {
    if (selectedPdf !== null) {
      if (state.project_budget !== "") {
        setAImessage(false);

        const acceptChangeRequestData = ContractChangeRequest.map(
          (milestone, index) => ({
            milestone: milestone.id,
            milestone_name: milestone.milestone,
            description: milestone.milestone_description,
            price: milestone.milestone_amount,
            comment: "New milestone changes updated",
          })
        );

        const data = {
          changeRequestData: acceptChangeRequestData[0],
          project: changeprojectid,
          milestone_id: individualMileStone?.id,
        };

        if (individualMileStone) {
          setLoader(true);

          let api = "/cvault/milestone-change-request/";
          try {
            const response = await axios.post(api, data, { headers: headers });
            setLoader(false);
          } catch (erorr) {
            setLoader(false);
          }
        }
        try {
          setChangeContract(false);
          const formData = new FormData();
          formData.set("budget", state.project_budget);
          formData.set("milestone_details", JSON.stringify(inputList));
          formData.set("project_id", changeprojectid);
          if (selectedPdf) {
            formData.set("pdf_path", selectedPdf);
          }
          if (individualMileStone) {
            formData.set("milestone_id", individualMileStone?.id);
          }
          setLoader(true);
          const response = await axios.post(
            "/cvault/contract-reupload/",
            formData,
            {
              headers: headers,
            }
          );
          setReUplodacontract(false);
          setLoader(false);
          // setChangeProjectid("");
          setReuploadSelectedPdf(null);

          getProjectlist();
          if (individualMileStone !== null) {
            handleMilestoneModal(projectid);
            toast.success("Revised milestone sent to owner for approval");
          } else {
            toast.success("Revised contract sent to owner for approval");
          }
          setSelectedPdf(null);
          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
        } catch (error) {
          setLoader(false);
          setReuploadSelectedPdf(null);
          setReUplodacontract(false);
          setChangeContract(false);

          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
          setSelectedPdf(null);
          toast.error("Please try again later.");
        }
      } else {
        toast.error("Please enter Project budget");
        setShouldFocus(true);
      }
    } else {
      toast.error("Please Upload Contract pdf");
    }
  };

  useEffect(() => {
    if (shouldFocus && projectBudgetRef.current) {
      projectBudgetRef.current.focus();
      setShouldFocus(false);
    }
  }, [shouldFocus]);

  useEffect(() => {
    setFileError("");
  }, [Changecontract, editIndex, newMessage]);

  useEffect(() => {
    setOpenSections({});
  }, [Changecontract, editIndex]);

  const genAIChange = async (event) => {
    setGenAI(event.target.checked);
  };

  const openPopupWindow = () => {
    if (popupWindow && !popupWindow.closed) {
      popupWindow.focus();
      popupWindow.location.href = "http://localhost:4200/";
    } else {
      const newWindow = window.open("http://localhost:4200/", "tab");
      setPopupWindow(newWindow);
    }
  };

  function showMessage(message) {
    // Check if message.chat is a string
    if (typeof message === "string") {
      // Try to parse it as JSON
      try {
        const parsedData = JSON.parse(message);
        // If parsing is successful, you can work with parsedData (as a JSON object)
        return Object.entries(parsedData)
          .filter(([_, value]) => value !== 0 && value !== null && value !== "") // Filter out unwanted values
          .map(([key, value]) => (
            <div key={key}>
              <span style={{ fontWeight: 500 }}>{key}</span> : {value}
            </div>
          ));
      } catch (e) {
        // If it's not valid JSON, just treat it as a regular string
        return message.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ));
      }
    } else {
      // If it's not a string, handle it accordingly
      console.log("Invalid or unexpected message:", message);
    }
  }

  return (
    <div className="mt-2 p-4">
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {(loader || isContractLoader) && (
          <div className="loader-overlay">
            {AImessage && (
              <span className="loader-message">
                AI is working on fetching the Milestone details from the
                uploaded Contract. Please wait...
              </span>
            )}
            {isContractLoader && (
              <span className="loader-message">
                Fetching contract details from cloud storage. Please wait...
              </span>
            )}
            <BarLoader
              color="#F5AE41"
              width={400}
              height={10}
              className="loader"
              loading={loader || isContractLoader}
            />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between mx-1 mb-3">
        <div>
          <h4 className="fw-bold">Project List - Contractor View</h4>
        </div>
        <div>
          <button
            className="btn btn-cvault me-2"
            onClick={() => {
              navigate("/AddProject");
            }}
          >
            Add Project
          </button>
          <button className="btn btn-cvault project">
            {/* <a href="http://52.1.212.197:4201/" target="tab1"> */}
            <a
              href="https://qd.cvaultco.com/authentication/signin"
              target="tab1"
            >
              <span>Project Management</span>
            </a>
          </button>
        </div>
      </div>
      <div className="card card-cvault">
        <div className="card-body" style={{ width: "100%" }}>
          <DataGrid
            rows={projectList}
            columns={columns.map((column) => ({
              ...column,
              headerClassName,
              renderHeader,
            }))}
            getRowId={(row) => row.project_id}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            hideFooterSelectedRowCount
            localeText={{ noRowsLabel: loaderMsg }}
          />
        </div>
      </div>
      <div> </div>
      {selectedProject != "" ? (
        <div className="card card-cvault mt-4 p-3" id="expandOfProjects">
          <div>
            <div className="d-flex justify-content-between">
              <div></div>
            </div>

            <CMilestoneList
              milestoneid={milestoneList}
              projectid={projectid}
              setSelectedProject={setSelectedProject}
              milestoneListdata={milestoneListdata}
              setMilestoneListdata={setMilestoneListdata}
              getProjectlist={getProjectlist}
              projectStatus={Notsigned}
              // setSelectedProject={setSelectedProject}
              projectname={projectname}
              notification={notificationData}
              handleMilestoneModal={handleMilestoneModal}
              setChangeContract={setChangeContract}
              // setChangeProjectname={setChangeProjectname}
              setChangeProjectid={setChangeProjectid}
              MilestonechangeRequest={MilestonechangeRequest}
              handlegetchat={handlegetchat}
              setIndividualMileStone={setIndividualMileStone}
              setProjectLevelViewModal={setProjectLevelViewModal}
              setProjectLevelContractorFiles={setProjectLevelContractorFiles}
              setMileDocs={setMileDocs}
              setDocHeader={setDocHeader}
              projectLoaderMsg={loaderMsg}
            />
          </div>
        </div>
      ) : null}

      <Modal
        open={Changecontract}
        onClose={() => {
          setChangeContract(false);
          setSelectedPdf(null);
          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
          setEditmilestone(false);

          setChatView(false);
          setEditIndex(null);
          setIndividualMileStone(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...modelStyle,
            width: individualMileStone ? "85%" : "100%",
            height: individualMileStone ? "90vh" : "100vh",
            maxHeight: individualMileStone ? "90vh" : "100vh",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              // height: "100vh",
            }}
          >
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className={`d-flex  justify-content-between align-items-center ps-3 pe-2 ${
                individualMileStone === null ? "pt-1" : "pt-2"
              }`}
            >
              <div style={{ width: "100%" }}>
                {" "}
                <div style={{ width: "100%" }}>
                  {individualMileStone === null ? (
                    <div style={{ width: "100%" }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <h5>Project Change Request</h5>
                        <IoIosClose
                          className="fs-1 cursor"
                          onClick={() => {
                            setChangeContract(false);
                            setContractChangeRequest([]);
                            setChatView(false);
                            setEditIndex(null);
                            setIndividualMileStone(null);
                          }}
                        />
                      </div>
                      <div className="row">
                        <div className="col projectname mb-1">
                          {" "}
                          <span style={{ color: "black" }}>Project</span>
                          <span> : </span>{" "}
                          <span className="projectname">
                            {" "}
                            {changeprojectname}
                          </span>
                        </div>
                        <div className="col">
                          <div className="d-flex justify-content-between">
                            <span
                              className={`${
                                chatview ? "projectname" : "projectname_black"
                              }`}
                              style={{
                                marginLeft: "1%",
                              }}
                            >
                              {chatview ? "Chat Room" : "Milestone(s)"}
                            </span>
                            {chatview && (
                              <div className="cr-action-buttons">
                                <button
                                  className="btn cr-deny-btn"
                                  onClick={() => {
                                    cancelCRRequest(milestonechangeRequestchat);
                                  }}
                                  disabled={
                                    ContractChangeRequest[editIndex || 0]
                                      ?.cr_notification === ""
                                  }
                                  style={{ fontSize: "12px" }}
                                >
                                  <span>CR Deny</span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <h5 className="col">Milestone Change Request</h5>
                      {chatview && (
                        <div className="col d-flex align-items-center justify-content-between">
                          <h5
                            className=" projectname"
                            style={{ marginLeft: "2%" }}
                          >
                            Chat Room
                          </h5>
                          <IoIosClose
                            className="fs-1 cursor"
                            onClick={() => {
                              setChangeContract(false);
                              setContractChangeRequest([]);
                              setChatView(false);
                              setEditIndex(null);
                              setIndividualMileStone(null);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div>
              <div
                className="d-flex row custom-row"
                style={{
                  padding: individualMileStone
                    ? "0px 0 .5rem 1.5rem"
                    : "0px 0 .5rem .5rem",
                }}
              >
                <div
                  className={chatview ? "col-md-6" : "col-md-6 "}
                  style={{
                    height: isMobile ? "" : "calc(100vh - 150px)",
                    overflow: "auto",
                    padding: "0px 25px",
                    background: individualMileStone ? "bisque" : "",
                  }}
                >
                  {" "}
                  {!individualMileStone && selectedPdfFile && (
                    <>
                      <iframe
                        title="PDF Viewer"
                        style={{
                          width: "100%",
                          height: "98%",
                          border: "none",
                          objectFit: "contain",
                        }}
                        src={selectedPdfFile}
                      />
                    </>
                  )}
                  {individualMileStone && (
                    <>
                      {ContractChangeRequest.map((milestone, index) => (
                        <>
                          {individualMileStone === null ? (
                            <div
                              key={index}
                              className="row custom-row pt-2"
                              style={{ margin: "0px !important" }}
                            >
                              <div className={chatview ? "col-md-12" : ""}>
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ minWidth: "250px" }}
                                    >
                                      <label className="milestonechangeRequest">
                                        {index + 1 + " "}:
                                      </label>

                                      <span
                                        style={{
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",

                                          marginLeft: "5px",
                                        }}
                                        className="text-primary"
                                      >
                                        {milestone?.milestone}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-end">
                                    <span
                                      className="text-danger me-3"
                                      style={{ fontWeight: 450 }}
                                    >
                                      {milestone?.temp_notification}
                                    </span>
                                    <div className="d-flex">
                                      <div className="d-flex">
                                        <p
                                          style={{
                                            margin: "0px",
                                            marginBottom: "0px",
                                            marginLeft: "0px",
                                          }}
                                        >
                                          Amount:{" "}
                                          <span className="text-primary me-3">
                                            $
                                            {String(milestone?.milestone_amount)
                                              .replace(".00", "")
                                              .replace("$", "")}
                                          </span>
                                        </p>{" "}
                                      </div>
                                    </div>

                                    {individualMileStone === null && (
                                      <div className="text-end">
                                        <Tooltip
                                          title={"Raise a Change Request"}
                                        >
                                          <FontAwesomeIcon
                                            icon={faEdit}
                                            className="text-success cursor fs-5"
                                            onClick={() => {
                                              handlegetchat(milestone);
                                              setEditIndex(index);
                                              if (
                                                milestone?.temp_notification ===
                                                ""
                                              ) {
                                                handlegetchat(milestone);
                                                const inputElement =
                                                  document.getElementById(
                                                    "chatInput"
                                                  );
                                                if (inputElement) {
                                                  inputElement.focus();
                                                }
                                              }
                                            }}
                                          />
                                        </Tooltip>
                                      </div>
                                    )}
                                    {milestone?.cr_notification ===
                                      "CR raised" &&
                                    milestone?.temp_notification !==
                                      "CR saved" ? (
                                      <div className="ms-2">
                                        <Tooltip>
                                          <img
                                            src={BellIcon}
                                            alt="bellicon"
                                            style={{
                                              width: "1.4rem",
                                              height: "1.4rem",
                                              objectFit: "cover",
                                              cursor: "pointer",
                                              marginBottom: "2px",
                                            }}
                                            className="shake-top"
                                            onClick={() => {
                                              handlegetchat(milestone);
                                              setEditIndex(index);
                                            }}
                                          />
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      <div
                                        className="ms-2"
                                        style={{ width: "23px" }}
                                      ></div>
                                    )}
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex align-items-center justify-content-between pt-1 pb-1">
                                    <label style={{ fontWeight: 500 }}>
                                      Milestone Description
                                    </label>
                                    {milestone?.original_amount !== null &&
                                      milestone?.original_amount !== "" && (
                                        <div style={{ marginRight: "32px" }}>
                                          Original Amount:{" "}
                                          <span className="text-primary">
                                            {milestone.original_amount.includes(
                                              "$"
                                            )
                                              ? milestone.original_amount.replace(
                                                  ".00",
                                                  ""
                                                )
                                              : `${
                                                  "$" +
                                                  milestone.original_amount.replace(
                                                    ".00",
                                                    ""
                                                  )
                                                }`}
                                          </span>
                                        </div>
                                      )}
                                  </div>

                                  {milestone?.milestone_description !== "" && (
                                    <div
                                      style={{
                                        marginTop: "2px",
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                        maxHeight: individualMileStone
                                          ? "auto"
                                          : "200px",
                                        height: individualMileStone
                                          ? "auto"
                                          : "150px",
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",
                                        // fontFamily: "sans-serif",
                                        background:
                                          editIndex === index
                                            ? "bisque"
                                            : "white",
                                        padding: "10px",
                                        border:
                                          editIndex === index
                                            ? "1px solid #0d6efd"
                                            : "1px solid lightgray",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <div>
                                        {milestone.milestone_description}
                                      </div>
                                      <div>
                                        {milestone?.change_request?.length >
                                          0 &&
                                          milestone?.change_request.map(
                                            (request, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  marginTop: "5px",
                                                }}
                                              >
                                                <strong>
                                                  {
                                                    request?.change_request_heading
                                                  }
                                                  {":"}
                                                </strong>

                                                <div>
                                                  {"Initiated Date: " +
                                                    request.initiate_date}
                                                </div>
                                                <div>
                                                  {
                                                    request
                                                      ?.change_request_description?.[0]
                                                      ?.user_name
                                                  }{" "}
                                                  (
                                                  {
                                                    request
                                                      ?.change_request_description?.[0]
                                                      ?.user_role
                                                  }
                                                  ) initiated a change request
                                                </div>
                                                {request?.change_request_description?.map(
                                                  (msg, msgIndex) => (
                                                    <div>
                                                      <div key={msgIndex}>
                                                        <span>
                                                          {msg?.user_name} (
                                                          {msg?.user_role}):{" "}
                                                          {msg?.message}
                                                        </span>

                                                        {msg?.files_path
                                                          ?.length > 0 && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <Tooltip
                                                              title={
                                                                !expanded[
                                                                  msgIndex
                                                                ]
                                                                  ? "Click to expand files"
                                                                  : "Click to collpase files"
                                                              }
                                                              placement="right"
                                                            >
                                                              <div
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                className="d-flex align-items-center"
                                                                onClick={() =>
                                                                  toggleExpand(
                                                                    msgIndex
                                                                  )
                                                                }
                                                              >
                                                                <span
                                                                  style={{
                                                                    transition:
                                                                      "transform 0.3s ease",

                                                                    fontSize:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    version="1.1"
                                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                    viewBox="0 0 512 512"
                                                                    width={15}
                                                                    height={15}
                                                                    style={{
                                                                      marginBottom:
                                                                        "4px",
                                                                      enableBackground:
                                                                        "new 0 0 512 512",
                                                                    }}
                                                                    xmlSpace="preserve"
                                                                  >
                                                                    <g>
                                                                      <path
                                                                        d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                        fill={
                                                                          "#000"
                                                                        }
                                                                      />
                                                                    </g>
                                                                  </svg>
                                                                  <span
                                                                    className="text-primary"
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      marginLeft:
                                                                        "5px",
                                                                    }}
                                                                  >
                                                                    {msg
                                                                      ?.files_path
                                                                      ?.length ===
                                                                    1
                                                                      ? "1 document"
                                                                      : `${msg?.files_path?.length} documents`}
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </Tooltip>
                                                          </div>
                                                        )}
                                                      </div>
                                                      <Collapse
                                                        in={expanded[msgIndex]}
                                                        style={{
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        <ol
                                                          style={{
                                                            marginBottom:
                                                              "0rem",
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {msg?.files_path?.map(
                                                            (
                                                              file,
                                                              fileIndex
                                                            ) => (
                                                              <li
                                                                key={fileIndex}
                                                              >
                                                                <span
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    textDecoration:
                                                                      "underline",
                                                                  }}
                                                                  onClick={() => {
                                                                    viewFiles(
                                                                      file
                                                                    );
                                                                  }}
                                                                >
                                                                  <i>
                                                                    {file
                                                                      .split(
                                                                        "/"
                                                                      )
                                                                      .pop()}
                                                                  </i>
                                                                </span>
                                                              </li>
                                                            )
                                                          )}
                                                        </ol>
                                                      </Collapse>
                                                    </div>
                                                  )
                                                )}

                                                {request?.revised_amount !==
                                                  null && (
                                                  <div>
                                                    Amount:{" "}
                                                    {request?.revised_amount
                                                      .replace("$$", "$")
                                                      .replace(".00", "")}
                                                  </div>
                                                )}
                                                <div>
                                                  {request?.accepted_date
                                                    ? "Accepted date: "
                                                    : "Denied date: "}
                                                  {request?.accepted_date ||
                                                    request?.denied_date}
                                                </div>
                                                <div>
                                                  {request?.accepted_denied_by}{" "}
                                                  <strong>
                                                    {request?.accepted_date
                                                      ? "accepted"
                                                      : "denied"}
                                                  </strong>{" "}
                                                  the change request
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              key={index}
                              className="row custom-row pt-2 mb-3"
                              style={{ margin: "0px !important" }}
                            >
                              <div className={chatview ? "col-md-12" : ""}>
                                <div className="">
                                  <div className="d-flex align-items-center">
                                    <label
                                      className="milestonechangeRequest me-2"
                                      style={{ minWidth: "165px" }}
                                    >
                                      Project
                                    </label>
                                    <span>:</span>
                                    <span className="text-primary ms-2">
                                      {changeprojectname}
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <label
                                      className="milestonechangeRequest me-2"
                                      style={{ minWidth: "165px" }}
                                    >
                                      Milestone
                                    </label>
                                    <span>:</span>
                                    <span className="text-primary ms-2">
                                      {milestone?.milestone_number +
                                        ". " +
                                        milestone?.milestone}
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <label
                                      className="milestonechangeRequest me-2"
                                      style={{ minWidth: "165px" }}
                                    >
                                      Amount
                                    </label>
                                    <span>:</span>
                                    <span className="text-primary ms-2">
                                      $
                                      {String(milestone?.milestone_amount)
                                        .replace(".00", "")
                                        .replace("$", "")}
                                    </span>
                                  </div>

                                  {milestone?.original_amount !== null &&
                                    milestone?.original_amount !== "" && (
                                      <div className="d-flex align-items-center">
                                        <label
                                          className="milestonechangeRequest me-2"
                                          style={{ minWidth: "165px" }}
                                        >
                                          Original Amount
                                        </label>
                                        <span>:</span>
                                        <span className="text-primary  ms-2">
                                          {milestone.original_amount.includes(
                                            "$"
                                          )
                                            ? milestone.original_amount.replace(
                                                ".00",
                                                ""
                                              )
                                            : `${
                                                "$" +
                                                milestone.original_amount.replace(
                                                  ".00",
                                                  ""
                                                )
                                              }`}
                                        </span>
                                      </div>
                                    )}
                                  <div className="d-flex align-items-center">
                                    <label
                                      className="milestonechangeRequest me-2"
                                      style={{ minWidth: "150px" }}
                                    >
                                      Milestone Description
                                    </label>
                                  </div>
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      overflowY: "auto",
                                      overflowX: "hidden",
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      height: "auto",
                                    }}
                                  >
                                    <div>
                                      {milestone?.milestone_description}
                                    </div>
                                    <div>
                                      {milestone?.change_request?.length > 0 &&
                                        milestone?.change_request.map(
                                          (request, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                marginTop: "5px",
                                              }}
                                            >
                                              <strong>
                                                {
                                                  request?.change_request_heading
                                                }
                                                {":"}
                                              </strong>

                                              <div>
                                                {"Initiated Date: " +
                                                  request.initiate_date}
                                              </div>
                                              <div>
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_name
                                                }{" "}
                                                (
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_role
                                                }
                                                ) initiated a change request
                                              </div>
                                              {request?.change_request_description?.map(
                                                (msg, msgIndex) => (
                                                  <div>
                                                    <div key={msgIndex}>
                                                      <span>
                                                        {msg?.user_name} (
                                                        {msg?.user_role}):{" "}
                                                        {msg?.message}
                                                      </span>

                                                      {msg?.files_path?.length >
                                                        0 && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <Tooltip
                                                            title={
                                                              !expanded[
                                                                msgIndex
                                                              ]
                                                                ? "Click to expand files"
                                                                : "Click to collpase files"
                                                            }
                                                            placement="right"
                                                          >
                                                            <div
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              className="d-flex align-items-center"
                                                              onClick={() =>
                                                                toggleExpand(
                                                                  msgIndex
                                                                )
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  transition:
                                                                    "transform 0.3s ease",

                                                                  fontSize:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  version="1.1"
                                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                  viewBox="0 0 512 512"
                                                                  width={15}
                                                                  height={15}
                                                                  style={{
                                                                    marginBottom:
                                                                      "4px",
                                                                    enableBackground:
                                                                      "new 0 0 512 512",
                                                                  }}
                                                                  xmlSpace="preserve"
                                                                >
                                                                  <g>
                                                                    <path
                                                                      d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                      fill={
                                                                        "#000"
                                                                      }
                                                                    />
                                                                  </g>
                                                                </svg>
                                                                <span
                                                                  className="text-primary"
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    marginLeft:
                                                                      "5px",
                                                                  }}
                                                                >
                                                                  {msg
                                                                    ?.files_path
                                                                    ?.length ===
                                                                  1
                                                                    ? "1 document"
                                                                    : `${msg?.files_path?.length} documents`}
                                                                </span>
                                                              </span>
                                                            </div>
                                                          </Tooltip>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <Collapse
                                                      in={expanded[msgIndex]}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <ol
                                                        style={{
                                                          marginBottom: "0rem",
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        {msg?.files_path?.map(
                                                          (file, fileIndex) => (
                                                            <li key={fileIndex}>
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                                onClick={() => {
                                                                  viewFiles(
                                                                    file
                                                                  );
                                                                }}
                                                              >
                                                                <i>
                                                                  {file
                                                                    .split("/")
                                                                    .pop()}
                                                                </i>
                                                              </span>
                                                            </li>
                                                          )
                                                        )}
                                                      </ol>
                                                    </Collapse>
                                                  </div>
                                                )
                                              )}

                                              {request?.revised_amount !==
                                                null && (
                                                <div>
                                                  Amount:{" "}
                                                  {request?.revised_amount
                                                    .replace("$$", "$")
                                                    .replace(".00", "")}
                                                </div>
                                              )}
                                              <div>
                                                {request?.accepted_date
                                                  ? "Accepted date: "
                                                  : "Denied date: "}
                                                {request?.accepted_date ||
                                                  request?.denied_date}
                                              </div>
                                              <div>
                                                {request?.accepted_denied_by}{" "}
                                                <strong>
                                                  {request?.accepted_date
                                                    ? "accepted"
                                                    : "denied"}
                                                </strong>{" "}
                                                the change request
                                              </div>
                                            </div>
                                          )
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ))}
                    </>
                  )}
                </div>
                <div
                  className="col-md-6 pt-2"
                  style={{
                    borderLeft: "1px solid #ccc",
                    height: !isMobile
                      ? !individualMileStone
                        ? "calc(100vh - 135px)"
                        : "calc(100vh - 150px)"
                      : "",
                    overflow: "auto",
                  }}
                >
                  {chatview && (
                    <div>
                      <div className="d-flex align-items-center justify-content-between">
                        {individualMileStone !== null && <div />}

                        {individualMileStone !== null &&
                          ContractChangeRequest[editIndex || 0]
                            ?.amount_status !== "noChange" &&
                          ContractChangeRequest[editIndex || 0]
                            ?.amount_status && (
                            <div
                              style={{ marginRight: "10px", fontSize: "14px" }}
                            >
                              <span style={{ fontWeight: 500 }}>
                                Revised Amount:{" "}
                              </span>

                              <span className="text-primary">
                                $
                                {(() => {
                                  const item =
                                    ContractChangeRequest[editIndex || 0] || {};

                                  const revisedAmount =
                                    typeof item.revised_amount === "number"
                                      ? item.revised_amount // Directly use number if already a number
                                      : parseFloat(
                                          (item.revised_amount || "0").replace(
                                            /[^0-9.e+-]/g,
                                            ""
                                          )
                                        ) || 0; // Preserve scientific notation

                                  const price =
                                    typeof item.milestone_amount === "number"
                                      ? item.milestone_amount
                                      : parseFloat(
                                          (
                                            item.milestone_amount || "0"
                                          ).replace(/[^0-9.e+-]/g, "")
                                        ) || 0;

                                  return item.amount_status === "Increase"
                                    ? Number(
                                        revisedAmount + price
                                      ).toLocaleString("en-US")
                                    : Number(
                                        price - revisedAmount
                                      ).toLocaleString("en-US");
                                })()}
                              </span>
                            </div>
                          )}
                      </div>

                      <div className="">
                        {individualMileStone === null && (
                          <>
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center">
                                <ArrowBackIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                  onClick={() => {
                                    setChatView(false);
                                    setEditIndex(null);
                                  }}
                                />

                                <div className="text-dark ms-1">
                                  <span style={{ fontWeight: 500 }}>
                                    Milestone :{" "}
                                  </span>
                                  <span>
                                    {editIndex + 1 || 1}.{" "}
                                    {milestonechangeRequestchat?.milestone}
                                  </span>
                                </div>
                              </div>

                              <div className="d-flex align-items-center">
                                <div
                                  style={{
                                    marginRight: "7px",
                                    fontSize: "14px",
                                  }}
                                >
                                  {ContractChangeRequest[editIndex || 0]
                                    ?.amount_status !== "noChange" &&
                                    ContractChangeRequest[editIndex || 0]
                                      ?.amount_status && (
                                      <div>
                                        <span style={{ fontWeight: 500 }}>
                                          {" "}
                                          Revised Amount:{" "}
                                        </span>
                                        <span className="text-primary">
                                          $
                                          {(() => {
                                            const item =
                                              ContractChangeRequest[
                                                editIndex || 0
                                              ] || {};

                                            const revisedAmount =
                                              typeof item.revised_amount ===
                                              "number"
                                                ? item.revised_amount // Directly use number if already a number
                                                : parseFloat(
                                                    (
                                                      item.revised_amount || "0"
                                                    ).replace(/[^0-9.e+-]/g, "")
                                                  ) || 0; // Preserve scientific notation

                                            const price =
                                              typeof item.milestone_amount ===
                                              "number"
                                                ? item.milestone_amount
                                                : parseFloat(
                                                    (
                                                      item.milestone_amount ||
                                                      "0"
                                                    ).replace(/[^0-9.e+-]/g, "")
                                                  ) || 0;

                                            return item.amount_status ===
                                              "Increase"
                                              ? Number(
                                                  revisedAmount + price
                                                ).toLocaleString("en-US")
                                              : Number(
                                                  price - revisedAmount
                                                ).toLocaleString("en-US");
                                          })()}
                                        </span>
                                      </div>
                                    )}
                                </div>
                                {/* <button
                                  className="btn detail-btn me-2 bg-danger text-white"
                                  onClick={() => {
                                    cancelCRRequest(milestonechangeRequestchat);
                                  }}
                                  disabled={
                                    ContractChangeRequest[editIndex || 0]
                                      ?.cr_notification === ""
                                  }
                                  style={{ fontSize: "12px" }}
                                >
                                  <span>CR Deny</span>
                                </button> */}
                              </div>
                            </div>

                            <div
                              style={{
                                fontSize: "13px",
                                paddingLeft: "20px",
                                borderBottom: "1px solid lightgray",
                                display: "-webkit-box",
                                WebkitLineClamp: 3, // Limit to 2 lines
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                            >
                              {
                                milestonechangeRequestchat?.milestone_description
                              }
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {chatview && (
                    <>
                      <div className="w-100">
                        <div
                          style={{
                            // border: "1px solid #ccc",
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              height: isMobile
                                ? "250px"
                                : ContractChangeRequest[editIndex || 0]?.files
                                    .length > 0
                                ? individualMileStone
                                  ? "calc(100vh - 390px)"
                                  : "calc(100vh - 420px)"
                                : individualMileStone
                                ? "calc(100vh - 390px)"
                                : "calc(100vh - 420px)",
                              overflowY: "scroll",
                            }}
                          >
                            {Nochat && (
                              <div className="d-flex justify-content-center">
                                <span className="text-secondary text-center fw-normal">
                                  No Change Request History available
                                </span>
                              </div>
                            )}
                            {messages.map((message, index) => (
                              <>
                                <div
                                  key={index}
                                  className={`message ${
                                    message?.user == "Contractor"
                                      ? "user-message"
                                      : "ai-message"
                                  }`}
                                  style={{ fontSize: "14px", maxWidth: "80%" }}
                                >
                                  {typeof message.chat === "string"
                                    ? showMessage(message.chat)
                                    : typeof message.chat === "object"
                                    ? Object.entries(message.chat)
                                        .filter(
                                          ([_, value]) =>
                                            value !== 0 &&
                                            value !== null &&
                                            value !== ""
                                        ) // Filter out unwanted values
                                        .map(([key, value]) => (
                                          <div key={key}>
                                            <span style={{ fontWeight: 500 }}>
                                              {key}
                                            </span>{" "}
                                            : {value}
                                          </div>
                                        ))
                                    : message.chat}
                                </div>
                                {message?.files?.length > 0 && (
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      textAlign:
                                        message?.user === "Owner" ? "" : "end",
                                      margin:
                                        message?.user === "Owner"
                                          ? ""
                                          : "0px 8px",
                                    }}
                                  >
                                    <button
                                      onClick={() => handleToggleView(index)}
                                      style={{
                                        border: "none",
                                        background: "lightgray",
                                        borderRadius: "4px",
                                        backgroundColor: "rgb(247 247 247)",
                                        cursor: "pointer",
                                        marginTop: "5px",
                                        padding: "5px",
                                      }}
                                    >
                                      <div className="d-flex align-items-center">
                                        <div
                                          style={{
                                            fontWeight: 450,
                                            fontSize: "13px",
                                          }}
                                        >
                                          View Files
                                        </div>

                                        <div className="ms-1">
                                          {openSections[index] ? (
                                            <KeyboardArrowUpIcon
                                              style={{ fontSize: "16px" }}
                                            />
                                          ) : (
                                            <KeyboardArrowDownIcon
                                              style={{ fontSize: "16px" }}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </button>

                                    <div
                                      id={`files-${index}`}
                                      style={{
                                        display: openSections[index]
                                          ? "block"
                                          : "none",
                                        marginTop: "5px",
                                        width: "80%",
                                        marginLeft:
                                          message?.user === "Owner"
                                            ? ""
                                            : "auto",
                                        justifyContent:
                                          message?.user === "Owner"
                                            ? ""
                                            : "end",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        {/* Left Arrow Button */}
                                        {message?.files?.length > 2 && (
                                          <button
                                            ref={leftBtnRef}
                                            onClick={() =>
                                              handleScrollLeft(index)
                                            }
                                            // disabled={isAtStart(index)} // Disable if at the start
                                            style={{
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                              padding: "5px",
                                              color: "gray",
                                            }}
                                          >
                                            <KeyboardArrowLeftIcon />
                                          </button>
                                        )}

                                        {/* Files Container */}
                                        <div
                                          id={`scroll-container-${index}`}
                                          ref={containerRef}
                                          style={{
                                            display: "flex",
                                            gap: "10px",
                                            overflowX:
                                              message?.files?.length > 2
                                                ? "hidden"
                                                : "none", // Enable horizontal scrolling if more than 2 files
                                            flexWrap: "nowrap",
                                            maxWidth: "calc(100% - 10px)", // Adjust width to fit the left and right arrows
                                            scrollBehavior: "smooth", // Add smooth scrolling behavior
                                            flexShrink: 0, // Prevent shrinking
                                            marginLeft:
                                              message?.user !== "Owner"
                                                ? "auto"
                                                : "",
                                          }}
                                          onScroll={checkScroll}
                                        >
                                          {message.files.map(
                                            (item, fileIndex) => (
                                              <div
                                                key={fileIndex} // Make sure this is a unique key
                                                className="preview-item group relative inline-block text-sm text-token-text-primary w-100"
                                                style={{
                                                  borderRadius: "4px",
                                                  border: "1px solid lightgray",
                                                  padding: "3px",
                                                  width: "200px", // Set a fixed width for each file item
                                                }}
                                              >
                                                <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl">
                                                  <div className="d-flex align-items-center">
                                                    <Tooltip
                                                      title={`Click to view`}
                                                      placement="top"
                                                    >
                                                      <div
                                                        style={{
                                                          // width: "100%",
                                                          color: "gray",
                                                          cursor: "pointer",
                                                        }}
                                                        className="d-flex flex-row align-items-center gap-2"
                                                      >
                                                        <TextSnippetIcon
                                                          style={{
                                                            width: "25px",
                                                            height: "25px",
                                                            color:
                                                              "rgb(128 175 215)",
                                                            opacity: "0.9",
                                                          }}
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <div
                                                      style={{
                                                        fontSize: "13px",
                                                        marginRight: "3px",
                                                        marginLeft: "2px",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        if (item?.type) {
                                                          setContractDocuments(
                                                            true
                                                          );
                                                          setSelectedContractDoc(
                                                            URL.createObjectURL(
                                                              item.blob
                                                            )
                                                          );
                                                          const newTab = false;
                                                          if (newTab) {
                                                            if (
                                                              item.type ===
                                                              "image"
                                                            ) {
                                                              newTab.document.write(
                                                                `<img src="${URL.createObjectURL(
                                                                  item.blob
                                                                )}" style="height:100%; display:flex; margin:auto" />`
                                                              );
                                                              newTab.document.title =
                                                                "Image Preview";
                                                            } else if (
                                                              item.type ===
                                                              "video"
                                                            ) {
                                                              newTab.document.body.innerHTML = `<video controls autoplay style="width:100%; height:100vh;"><source src="${URL.createObjectURL(
                                                                item.blob
                                                              )}" type="${
                                                                item.file.type
                                                              }"></video>`;
                                                              newTab.document.title =
                                                                "Video Preview";
                                                            } else if (
                                                              item.type ===
                                                                "pdf" ||
                                                              item.type ===
                                                                "text"
                                                            ) {
                                                              newTab.document.body.innerHTML = `<iframe src="${URL.createObjectURL(
                                                                item.blob
                                                              )}" style="width:100%; height:100vh; border:none;"></iframe>`;
                                                              newTab.document.title =
                                                                "PDF/Text Preview";
                                                            }
                                                          }
                                                        } else {
                                                          viewFiles(item);
                                                        }
                                                      }}
                                                    >
                                                      {(() => {
                                                        const fileName = (
                                                          item.name || item
                                                        )
                                                          .split("/")
                                                          .pop()
                                                          .replace(" ", ""); // Extract filename from path
                                                        if (
                                                          fileName.length > 9
                                                        ) {
                                                          return (
                                                            fileName.slice(
                                                              0,
                                                              5
                                                            ) +
                                                            "..." +
                                                            fileName.slice(-4)
                                                          );
                                                        }
                                                        return fileName.replace(
                                                          / /g,
                                                          ""
                                                        );
                                                      })()}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>

                                        {/* Right Arrow Button */}
                                        {message?.files?.length > 2 && (
                                          <button
                                            ref={rightBtnRef}
                                            onClick={() =>
                                              handleScrollRight(index)
                                            }
                                            // disabled={isAtEnd(index)} // Disable if at the end
                                            style={{
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                              padding: "5px",
                                              color: "gray",
                                            }}
                                          >
                                            <KeyboardArrowRightIcon />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            ))}
                          </div>

                          {ContractChangeRequest[editIndex || 0] && (
                            <div className="col-12 mt-2" key={editIndex || 0}>
                              <div className="row align-items-center justify-content-between">
                                <div className="col-md-7 d-flex align-items-center ">
                                  <label className="d-flex align-items-center pointer">
                                    <input
                                      type="checkbox"
                                      checked={
                                        ContractChangeRequest[editIndex || 0]
                                          .amount_status === "noChange"
                                      }
                                      onChange={() =>
                                        handleAmountStatusChange(
                                          editIndex || 0,
                                          "noChange"
                                        )
                                      }
                                      style={{
                                        margin: 0,
                                        padding: 0,
                                        width: "auto",
                                      }}
                                    />
                                    <span
                                      className="ms-1"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {" "}
                                      No Change{" "}
                                    </span>
                                  </label>
                                  <div className="d-flex align-items-center ms-3">
                                    <label className="d-flex align-items-center pointer">
                                      <input
                                        type="checkbox"
                                        checked={
                                          ContractChangeRequest[editIndex || 0]
                                            .amount_status === "Increase"
                                        }
                                        onChange={() => {
                                          handleAmountStatusChange(
                                            editIndex || 0,
                                            "Increase"
                                          );
                                          const revisedElement =
                                            document.getElementById(
                                              "revised_amount_input"
                                            );
                                          setTimeout(() => {
                                            if (revisedElement) {
                                              revisedElement.focus();
                                            }
                                          }, 100);
                                        }}
                                        // disabled={ContractChangeRequest[editIndex || 0].noChange}
                                        style={{
                                          margin: 0,
                                          padding: 0,
                                          width: "auto",
                                        }}
                                      />
                                      <span
                                        className="ms-1"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {" "}
                                        Increase{" "}
                                      </span>
                                    </label>
                                    <label className="d-flex align-items-center pointer ms-2">
                                      <input
                                        type="checkbox"
                                        checked={
                                          ContractChangeRequest[editIndex || 0]
                                            .amount_status === "Decrease"
                                        }
                                        onChange={() => {
                                          handleAmountStatusChange(
                                            editIndex || 0,
                                            "Decrease"
                                          );
                                          const revisedElement =
                                            document.getElementById(
                                              "revised_amount_input"
                                            );
                                          setTimeout(() => {
                                            if (revisedElement) {
                                              revisedElement.focus();
                                            }
                                          }, 100);
                                        }}
                                        // disabled={ContractChangeRequest[editIndex || 0].noChange}
                                        style={{
                                          margin: 0,
                                          padding: 0,
                                          width: "auto",
                                        }}
                                      />
                                      <span
                                        className="ms-1"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {" "}
                                        Decrease{" "}
                                      </span>
                                    </label>
                                  </div>
                                </div>

                                <div className="col-md-5 justify-content-end">
                                  <div className="d-flex align-items-center justify-content-end">
                                    <label
                                      className="me-2"
                                      style={{ fontSize: "14px" }}
                                    >
                                      Amount:
                                    </label>
                                    <TextField
                                      id="revised_amount_input"
                                      ref={revisedAmountRef}
                                      size="small"
                                      value={
                                        ContractChangeRequest[editIndex || 0]
                                          .revised_amount
                                      }
                                      onChange={(e) =>
                                        milestoneInputChange(
                                          e,
                                          editIndex || 0,
                                          "revised_amount",
                                          ContractChangeRequest[editIndex || 0]
                                            ?.amount_status
                                        )
                                      }
                                      sx={{
                                        width: "150px",
                                        fontSize: "14px",
                                        "& .MuiInputBase-input": {
                                          fontSize: "14px",
                                        },
                                        "& .MuiInput-underline:before": {
                                          borderBottom: "1px solid black",
                                        },
                                        "& .MuiInput-underline:hover:before": {
                                          borderBottom:
                                            "1px solid black !important",
                                        },
                                        "& .MuiInput-underline:after": {
                                          borderBottom: "1px solid black",
                                        },
                                      }}
                                      InputProps={{
                                        inputComponent: NumericFormatCustom,
                                      }}
                                      disabled={
                                        ContractChangeRequest[editIndex || 0]
                                          ?.amount_status === "noChange"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              {ContractChangeRequest[editIndex || 0]?.error &&
                                ContractChangeRequest[editIndex || 0]
                                  ?.amount_status !== "noChange" && (
                                  <div
                                    style={{ fontSize: "12px" }}
                                    className="text-danger mt-1 text-end"
                                  >
                                    {ContractChangeRequest[editIndex || 0]
                                      ?.error || ""}
                                  </div>
                                )}
                            </div>
                          )}
                          <div
                            style={{
                              marginTop: "10px",
                              width: "100%",
                              height:
                                ContractChangeRequest[editIndex || 0]?.files
                                  .length > 0
                                  ? "90px"
                                  : "70px",
                            }}
                            className="me-4"
                          >
                            <div
                              style={{
                                width: "100%",
                                border: "1px solid lightgray",
                                borderBottom: "0px",
                                borderRadius: "5px 5px 0px 0px",
                                marginTop: "5px",
                              }}
                            >
                              {ContractChangeRequest[editIndex || 0]?.files
                                ?.length !== 0 && (
                                <div
                                  className="mt-1 -ml-1.5 d-flex flex-nowrap gap-2 overflow-x-auto p-1.5"
                                  style={{
                                    width: "95%",
                                    margin: "auto",
                                    overflowX: "auto",
                                  }}
                                >
                                  {ContractChangeRequest[
                                    editIndex || 0
                                  ]?.files?.map((item, index) => (
                                    <div
                                      key={index}
                                      className="preview-item group relative inline-block text-sm text-token-text-primary"
                                      style={{
                                        width: "220px",
                                        minWidth: "220px",
                                        marginLeft: "5px",
                                        marginBottom: "5px",
                                        whiteSpace: "nowrap",
                                        // overflow: 'hidden',
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl">
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            border: "1px solid lightgray",
                                            borderRadius: "4px",
                                            alignItems: "center", // Ensure alignment
                                            padding: "5px",
                                            cursor: "pointer", // Make it look clickable
                                          }}
                                          className="d-flex flex-row align-items-center gap-2"
                                          onClick={() => {
                                            // Define a common function to open the file

                                            if (item.type !== "others") {
                                              setContractDocuments(true);
                                              setSelectedContractDoc(
                                                URL.createObjectURL(item.blob)
                                              );
                                            } else {
                                              const link =
                                                document.createElement("a");
                                              link.href = item.blob;
                                              link.download = item.name; // Set file name for download
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                            }
                                            // const newTab = window.open();
                                            const newTab = false;
                                            if (newTab) {
                                              if (
                                                item?.type?.includes("image")
                                              ) {
                                                newTab.document.write(
                                                  `<img src="${URL.createObjectURL(
                                                    item.blob
                                                  )}" style="height:100%; display:flex; margin:auto" />`
                                                );
                                                newTab.document.title =
                                                  "Image Preview";
                                              } else if (
                                                item?.type === "video"
                                              ) {
                                                newTab.document.body.innerHTML = `<video controls autoplay style="width:100%; height:100vh;"><source src="${URL.createObjectURL(
                                                  item.blob
                                                )}" type="${
                                                  item.file.type
                                                }"></video>`;
                                                newTab.document.title =
                                                  "Video Preview";
                                              } else if (
                                                item?.type === "text"
                                              ) {
                                                const reader = new FileReader();
                                                reader.readAsText(item.blob);
                                                reader.onload = () => {
                                                  newTab.document.body.innerHTML = `<pre style="white-space: pre-wrap; word-wrap: break-word; font-family: monospace; padding: 20px;">${reader.result}</pre>`;
                                                  newTab.document.title =
                                                    "Text File Preview";
                                                };
                                              } else if (
                                                item.type.includes("pdf")
                                              ) {
                                                newTab.document.body.innerHTML = `<iframe src="${URL.createObjectURL(
                                                  item.blob
                                                )}" style="width:100%; height:100vh; border:none;"></iframe>`;
                                                newTab.document.title =
                                                  "PDF Preview";
                                              }
                                            }
                                          }}
                                        >
                                          {/* Icon */}
                                          <TextSnippetIcon
                                            style={{
                                              width: "30px",
                                              height: "30px",
                                              color: "#F5AE41",
                                              opacity: "0.9",
                                            }}
                                          />

                                          {/* File Name */}
                                          <div
                                            style={{
                                              fontSize: "13px",
                                              // marginLeft: "5px",
                                            }}
                                          >
                                            {(() => {
                                              const fileName = item?.name
                                                .split("/")
                                                .pop(); // Extract filename from path
                                              if (fileName.length > 20) {
                                                return (
                                                  fileName.slice(0, 20) +
                                                  "..." +
                                                  fileName.slice(-4)
                                                );
                                              }
                                              return fileName;
                                            })()}
                                          </div>
                                        </div>

                                        {/* Delete Button */}
                                        <button
                                          className="delete-btn"
                                          onClick={(e) => {
                                            e.stopPropagation(); // Prevent triggering the file open on delete click
                                            setFileError("");
                                            handleDelete(index, editIndex || 0);
                                          }}
                                        >
                                          X
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                            <TextField
                              placeholder="Type your message here..."
                              id="chatInput"
                              type="text"
                              multiline
                              rows={2.7}
                              className="chatinput"
                              disabled={
                                loader ||
                                sendcomment !== "enable" ||
                                (ContractChangeRequest[editIndex || 0]
                                  ?.amount_status !== "noChange" &&
                                  ContractChangeRequest[editIndex || 0]?.error)
                              }
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  paddingRight: "0px",
                                  border: "none", // Remove border for the input container
                                },
                                "& .MuiInputBase-input": {
                                  padding: "0px 10px",
                                  backgroundColor: "#FFF",
                                  borderRadius: "0px",
                                  border: "none", // Remove border for the input itself
                                  fontSize: "12px",
                                  width: "100%",
                                  borderBottomLeftRadius: "4px", // Radius for bottom-left corner
                                  borderBottomRightRadius: "4px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none", // Remove border for the input container
                                  borderLeft: "1px solid lightgray",
                                  borderRight: "1px solid lightgray",
                                  borderRadius: "0px",
                                },
                                // Focus state
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none", // Keep no border even when focused
                                    borderLeft: "1px solid lightgray",
                                    borderRight: "1px solid lightgray",
                                    borderRadius: "0px",
                                  },
                                // Hover state - remove border color
                                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderLeft: "1px solid lightgray", // Keep the same border when hovered
                                    borderRight: "1px solid lightgray", // Keep the same border when hovered
                                    borderRadius: "0px",
                                  },
                              }}
                              size="small"
                              fullWidth
                              value={newMessage}
                              onChange={(e) => {
                                const trimmedValue = e.target.value.trim();
                                if (
                                  trimmedValue ||
                                  e.target.value.length === 0
                                ) {
                                  setNewMessage(e.target.value);
                                }
                              }}
                              // onKeyDown={(e) => {
                              //   if (
                              //     e.key === "Enter" &&
                              //     sendcomment === "enable" &&
                              //     newMessage.trim() !== ""
                              //   ) {
                              //     // handleSendMessage();
                              //     if (individualMileStone === null) {
                              //       sendchat();
                              //     } else {
                              //       // setChangeContract(false);
                              //       // setSelectedPdf(null);
                              //       // setTextAreaValues([]);
                              //       // setEnableTextarea(
                              //       //   Array(ContractChangeRequest.length).fill(
                              //       //     false
                              //       //   )
                              //       // );
                              //       setEditmilestone(false);
                              //       Reuploadfeedback();
                              //       // setEnableTextarea(
                              //       //   Array(ContractChangeRequest.length).fill(
                              //       //     false
                              //       //   )
                              //       // );
                              //       setChatView(false);

                              //       setEditIndex(null);
                              //     }
                              //   }
                              // }}
                            />
                          </div>
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{
                              border: "1px solid lightgray",
                              borderTop: "0px",
                              borderBottomLeftRadius: "4px", // Radius for bottom-left corner
                              borderBottomRightRadius: "4px", // Radius for bottom-right corner
                              border: "1px solid lightgray",
                            }}
                          >
                            <div
                              className="d-flex align-items-center"
                              style={{ zIndex: 1 }}
                            >
                              <Tooltip placement="top" title="Upload a file">
                                <IconButton
                                  style={{
                                    border: "1px solid lightgray",
                                    margin: "5px",
                                    // padding:'2px'
                                  }}
                                  component="label"
                                >
                                  <AttachFileIcon
                                    style={{ fontSize: "16px" }}
                                  />
                                  <input
                                    type="file"
                                    accept=".pdf, .txt, image/*, video/*"
                                    hidden
                                    multiple
                                    onChange={(e) => {
                                      setFileError("");
                                      handleFileUploadChangeRequest(
                                        e,
                                        editIndex || 0
                                      );
                                    }}
                                    disabled={
                                      sendcomment !== "enable" ||
                                      (ContractChangeRequest[editIndex || 0]
                                        ?.amount_status !== "noChange" &&
                                        ContractChangeRequest[editIndex || 0]
                                          ?.error)
                                    }
                                  />
                                </IconButton>
                              </Tooltip>
                              {fileError !== "" && (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  {fileError}
                                </span>
                              )}
                            </div>
                            <>
                              {individualMileStone !== null ? (
                                <InputAdornment position="end">
                                  <Tooltip
                                    // title="Send Change Request"
                                    position="top"
                                  >
                                    <div>
                                      <Button
                                        onClick={() => {
                                          // handleSendMessage();
                                          if (individualMileStone === null) {
                                            sendchat();
                                          } else {
                                            setEditmilestone(false);
                                            Reuploadfeedback();
                                          }
                                        }}
                                        className="btn chatbtn"
                                        disabled={
                                          newMessage.trim() === "" ||
                                          (ContractChangeRequest[editIndex || 0]
                                            ?.amount_status !== "noChange" &&
                                            ContractChangeRequest[
                                              editIndex || 0
                                            ]?.error)
                                        }
                                        sx={{
                                          backgroundColor:
                                            sendcomment !== "enable"
                                              ? "gray"
                                              : "#013e6a",
                                          textTransform: "none",
                                          height: "auto",
                                          color: "white",
                                          fontSize: "12px",
                                          minWidth: 0,
                                          right: "5px",
                                          "&:hover": {
                                            backgroundColor:
                                              sendcomment !== "enable"
                                                ? "darkgray"
                                                : "#012a4a",
                                          },
                                          "&:disabled": {
                                            backgroundColor: "lightgray",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        Submit to Owner
                                      </Button>
                                    </div>
                                  </Tooltip>
                                </InputAdornment>
                              ) : (
                                <InputAdornment position="end">
                                  <Button
                                    onClick={() => {
                                      // handleSendMessage();
                                      if (individualMileStone === null) {
                                        sendchat();
                                      } else {
                                        setEditmilestone(false);
                                        Reuploadfeedback();
                                        setChatView(false);
                                        setEditIndex(null);
                                      }
                                    }}
                                    className="btn chatbtn"
                                    style={{
                                      backgroundColor: "#e9ecef",
                                      borderLeft: "0px",
                                      right: "7px",
                                      textTransform: "none",
                                      padding: "5px 7px",
                                      color:
                                        newMessage.trim() === "" ||
                                        (ContractChangeRequest[editIndex || 0]
                                          ?.amount_status !== "noChange" &&
                                          ContractChangeRequest[editIndex || 0]
                                            ?.error) ||
                                        sendcomment !== "enable"
                                          ? "gray"
                                          : "#013e6a",
                                    }}
                                    // disabled={sendcomment !== "enable"}
                                    disabled={
                                      newMessage.trim() === "" ||
                                      (ContractChangeRequest[editIndex || 0]
                                        ?.amount_status !== "noChange" &&
                                        ContractChangeRequest[editIndex || 0]
                                          ?.error) ||
                                      sendcomment !== "enable"
                                    }
                                    size="small"
                                  >
                                    Save Change
                                  </Button>
                                </InputAdornment>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {!chatview && (
                    <>
                      {ContractChangeRequest.map((milestone, index) => (
                        <>
                          {individualMileStone === null ? (
                            <div
                              key={index}
                              className="row custom-row pt-2"
                              style={{
                                margin: "0px !important",
                                background: "#f0f0f0",
                                borderRadius: "5px",
                                marginBottom: "10px",
                                marginLeft: "4px",
                              }}
                            >
                              <div className={chatview ? "col-md-12" : ""}>
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="d-flex align-items-center"
                                      style={{
                                        minWidth: "250px",
                                        maxWidth: "250px",
                                      }}
                                    >
                                      <label className="milestonechangeRequest">
                                        {index + 1 + " "}:
                                      </label>

                                      <span
                                        style={{
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",

                                          marginLeft: "5px",
                                        }}
                                        className="text-primary"
                                      >
                                        {milestone?.milestone}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-end">
                                    <span
                                      className="text-danger me-3"
                                      style={{
                                        fontWeight: 500,
                                        fontSize: "14px",
                                      }}
                                    >
                                      {milestone?.temp_notification}
                                    </span>
                                    <div className="d-flex">
                                      <div className="d-flex">
                                        <p
                                          style={{
                                            margin: "0px",
                                            marginBottom: "0px",
                                            marginLeft: "0px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          <span style={{ fontWeight: 500 }}>
                                            Amount:{" "}
                                          </span>
                                          <span className="text-primary me-3">
                                            $
                                            {String(milestone?.milestone_amount)
                                              .replace(".00", "")
                                              .replace("$", "")}
                                          </span>
                                        </p>{" "}
                                      </div>
                                    </div>

                                    {individualMileStone === null && (
                                      <div className="text-end">
                                        <Tooltip
                                          title={"Raise a Change Request"}
                                        >
                                          <FontAwesomeIcon
                                            icon={faEdit}
                                            className="text-success cursor fs-5"
                                            onClick={() => {
                                              handlegetchat(milestone);
                                              setEditIndex(index);
                                              if (
                                                milestone?.temp_notification ===
                                                ""
                                              ) {
                                                handlegetchat(milestone);
                                                const inputElement =
                                                  document.getElementById(
                                                    "chatInput"
                                                  );
                                                if (inputElement) {
                                                  inputElement.focus();
                                                }
                                              }
                                            }}
                                          />
                                        </Tooltip>
                                      </div>
                                    )}
                                    {milestone?.cr_notification ===
                                      "CR raised" &&
                                    milestone?.temp_notification !==
                                      "CR saved" ? (
                                      <div className="ms-2">
                                        <Tooltip>
                                          <img
                                            src={BellIcon}
                                            alt="bellicon"
                                            style={{
                                              width: "1.4rem",
                                              height: "1.4rem",
                                              objectFit: "cover",
                                              cursor: "pointer",
                                              marginBottom: "2px",
                                            }}
                                            className="shake-top"
                                            onClick={() => {
                                              handlegetchat(milestone);
                                              setEditIndex(index);
                                            }}
                                          />
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      <div
                                        className="ms-2"
                                        style={{ width: "23px" }}
                                      ></div>
                                    )}
                                  </div>
                                </div>

                                <div>
                                  {/* {editIndex === index ? (
                                <textarea
                                  style={{
                                    height: "150px",
                                    backgroundColor: "bisque",
                                  }}
                                  value={milestone?.milestone_description}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      index,
                                      "milestone_description"
                                    )
                                  }
                                />
                              ) : (
                                <textarea
                                  style={{ height: "150px" }}
                                  value={milestone?.milestone_description}
                                  readOnly
                                />
                              )} */}

                                  <div className="d-flex align-items-center justify-content-between pt-1 pb-1">
                                    <label
                                      style={{
                                        fontWeight: 500,
                                        fontSize: "14px",
                                      }}
                                    >
                                      Milestone Description
                                    </label>
                                    {milestone?.original_amount !== null &&
                                      milestone?.original_amount !== "" && (
                                        <div
                                          style={{
                                            marginRight: "32px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          <span style={{ fontWeight: 500 }}>
                                            {" "}
                                            Original Amount:{" "}
                                          </span>
                                          <span className="text-primary">
                                            {milestone.original_amount.includes(
                                              "$"
                                            )
                                              ? milestone.original_amount.replace(
                                                  ".00",
                                                  ""
                                                )
                                              : `${
                                                  "$" +
                                                  milestone.original_amount.replace(
                                                    ".00",
                                                    ""
                                                  )
                                                }`}
                                          </span>
                                        </div>
                                      )}
                                  </div>

                                  {milestone?.milestone_description !== "" && (
                                    <div
                                      style={{
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                        maxHeight: individualMileStone
                                          ? "auto"
                                          : "200px",
                                        height: individualMileStone
                                          ? "auto"
                                          : "auto",
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",

                                        border:
                                          editIndex === index
                                            ? "1px solid #0d6efd"
                                            : "1px solid lightgray",
                                        fontSize: "14px",
                                        border: "none",
                                        paddingBottom: "10px",
                                      }}
                                    >
                                      <div>
                                        {milestone.milestone_description}
                                      </div>
                                      <div>
                                        {milestone?.change_request?.length >
                                          0 &&
                                          milestone?.change_request.map(
                                            (request, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  marginTop: "5px",
                                                }}
                                              >
                                                <strong>
                                                  {
                                                    request?.change_request_heading
                                                  }
                                                  {":"}
                                                </strong>

                                                <div>
                                                  {"Initiated Date: " +
                                                    request.initiate_date}
                                                </div>
                                                <div>
                                                  {
                                                    request
                                                      ?.change_request_description?.[0]
                                                      ?.user_name
                                                  }{" "}
                                                  (
                                                  {
                                                    request
                                                      ?.change_request_description?.[0]
                                                      ?.user_role
                                                  }
                                                  ) initiated a change request
                                                </div>
                                                {request?.change_request_description?.map(
                                                  (msg, msgIndex) => (
                                                    <div>
                                                      <div key={msgIndex}>
                                                        <span>
                                                          {msg?.user_name} (
                                                          {msg?.user_role}):{" "}
                                                          {msg?.message}
                                                        </span>

                                                        {msg?.files_path
                                                          ?.length > 0 && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <Tooltip
                                                              title={
                                                                !expanded[
                                                                  msgIndex
                                                                ]
                                                                  ? "Click to expand files"
                                                                  : "Click to collpase files"
                                                              }
                                                              placement="right"
                                                            >
                                                              <div
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                className="d-flex align-items-center"
                                                                onClick={() =>
                                                                  toggleExpand(
                                                                    msgIndex
                                                                  )
                                                                }
                                                              >
                                                                <span
                                                                  style={{
                                                                    transition:
                                                                      "transform 0.3s ease",

                                                                    fontSize:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    version="1.1"
                                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                    viewBox="0 0 512 512"
                                                                    width={15}
                                                                    height={15}
                                                                    style={{
                                                                      marginBottom:
                                                                        "4px",
                                                                      enableBackground:
                                                                        "new 0 0 512 512",
                                                                    }}
                                                                    xmlSpace="preserve"
                                                                  >
                                                                    <g>
                                                                      <path
                                                                        d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                        fill={
                                                                          "#000"
                                                                        }
                                                                      />
                                                                    </g>
                                                                  </svg>
                                                                  <span
                                                                    className="text-primary"
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      marginLeft:
                                                                        "5px",
                                                                    }}
                                                                  >
                                                                    {msg
                                                                      ?.files_path
                                                                      ?.length ===
                                                                    1
                                                                      ? "1 document"
                                                                      : `${msg?.files_path?.length} documents`}
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </Tooltip>
                                                          </div>
                                                        )}
                                                      </div>
                                                      <Collapse
                                                        in={expanded[msgIndex]}
                                                        style={{
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        <ol
                                                          style={{
                                                            marginBottom:
                                                              "0rem",
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {msg?.files_path?.map(
                                                            (
                                                              file,
                                                              fileIndex
                                                            ) => (
                                                              <li
                                                                key={fileIndex}
                                                              >
                                                                <span
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    textDecoration:
                                                                      "underline",
                                                                  }}
                                                                  onClick={() => {
                                                                    viewFiles(
                                                                      file
                                                                    );
                                                                  }}
                                                                >
                                                                  <i>
                                                                    {file
                                                                      .split(
                                                                        "/"
                                                                      )
                                                                      .pop()}
                                                                  </i>
                                                                </span>
                                                              </li>
                                                            )
                                                          )}
                                                        </ol>
                                                      </Collapse>
                                                    </div>
                                                  )
                                                )}

                                                {request?.revised_amount !==
                                                  null && (
                                                  <div>
                                                    Amount:{" "}
                                                    {request?.revised_amount
                                                      .replace("$$", "$")
                                                      .replace(".00", "")}
                                                  </div>
                                                )}
                                                <div>
                                                  {request?.accepted_date
                                                    ? "Accepted date: "
                                                    : "Denied date: "}
                                                  {request?.accepted_date ||
                                                    request?.denied_date}
                                                </div>
                                                <div>
                                                  {request?.accepted_denied_by}{" "}
                                                  <strong>
                                                    {request?.accepted_date
                                                      ? "accepted"
                                                      : "denied"}
                                                  </strong>{" "}
                                                  the change request
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              {editIndex && (
                                <div
                                  key={index}
                                  className="row custom-row pt-2 mb-3"
                                  style={{ margin: "0px !important" }}
                                >
                                  <div className={chatview ? "col-md-12" : ""}>
                                    <div className="">
                                      <div className="d-flex align-items-center">
                                        <label
                                          className="milestonechangeRequest me-2"
                                          style={{ minWidth: "165px" }}
                                        >
                                          Project
                                        </label>
                                        <span>:</span>
                                        <span className="text-primary ms-2">
                                          {changeprojectname}
                                        </span>
                                      </div>
                                      <div className="d-flex align-items-center">
                                        <label
                                          className="milestonechangeRequest me-2"
                                          style={{ minWidth: "165px" }}
                                        >
                                          Milestone
                                        </label>
                                        <span>:</span>
                                        <span className="text-primary ms-2">
                                          {milestone?.milestone_number +
                                            ". " +
                                            milestone?.milestone}
                                        </span>
                                      </div>
                                      <div className="d-flex align-items-center">
                                        <label
                                          className="milestonechangeRequest me-2"
                                          style={{ minWidth: "165px" }}
                                        >
                                          Amount
                                        </label>
                                        <span>:</span>
                                        <span className="text-primary ms-2">
                                          $
                                          {String(milestone?.milestone_amount)
                                            .replace(".00", "")
                                            .replace("$", "")}
                                        </span>
                                      </div>

                                      {milestone?.original_amount !== null &&
                                        milestone?.original_amount !== "" && (
                                          <div className="d-flex align-items-center">
                                            <label
                                              className="milestonechangeRequest me-2"
                                              style={{ minWidth: "165px" }}
                                            >
                                              Original Amount
                                            </label>
                                            <span>:</span>
                                            <span className="text-primary  ms-2">
                                              {milestone.original_amount.includes(
                                                "$"
                                              )
                                                ? milestone.original_amount.replace(
                                                    ".00",
                                                    ""
                                                  )
                                                : `${
                                                    "$" +
                                                    milestone.original_amount.replace(
                                                      ".00",
                                                      ""
                                                    )
                                                  }`}
                                            </span>
                                          </div>
                                        )}
                                      <div className="d-flex align-items-center">
                                        <label
                                          className="milestonechangeRequest me-2"
                                          style={{ minWidth: "150px" }}
                                        >
                                          Milestone Description
                                        </label>
                                      </div>
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          overflowY: "auto",
                                          overflowX: "hidden",
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                          height: "auto",
                                        }}
                                      >
                                        <div>
                                          {milestone?.milestone_description}
                                        </div>
                                        <div>
                                          {milestone?.change_request?.length >
                                            0 &&
                                            milestone?.change_request.map(
                                              (request, index) => (
                                                <div
                                                  key={index}
                                                  style={{
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  <strong>
                                                    {
                                                      request?.change_request_heading
                                                    }
                                                    {":"}
                                                  </strong>

                                                  <div>
                                                    {"Initiated Date: " +
                                                      request.initiate_date}
                                                  </div>
                                                  <div>
                                                    {
                                                      request
                                                        ?.change_request_description?.[0]
                                                        ?.user_name
                                                    }{" "}
                                                    (
                                                    {
                                                      request
                                                        ?.change_request_description?.[0]
                                                        ?.user_role
                                                    }
                                                    ) initiated a change request
                                                  </div>
                                                  {request?.change_request_description?.map(
                                                    (msg, msgIndex) => (
                                                      <div>
                                                        <div key={msgIndex}>
                                                          <span>
                                                            {msg?.user_name} (
                                                            {msg?.user_role}):{" "}
                                                            {msg?.message}
                                                          </span>

                                                          {msg?.files_path
                                                            ?.length > 0 && (
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <Tooltip
                                                                title={
                                                                  !expanded[
                                                                    msgIndex
                                                                  ]
                                                                    ? "Click to expand files"
                                                                    : "Click to collpase files"
                                                                }
                                                                placement="right"
                                                              >
                                                                <div
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  className="d-flex align-items-center"
                                                                  onClick={() =>
                                                                    toggleExpand(
                                                                      msgIndex
                                                                    )
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      transition:
                                                                        "transform 0.3s ease",

                                                                      fontSize:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      version="1.1"
                                                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                      viewBox="0 0 512 512"
                                                                      width={15}
                                                                      height={
                                                                        15
                                                                      }
                                                                      style={{
                                                                        marginBottom:
                                                                          "4px",
                                                                        enableBackground:
                                                                          "new 0 0 512 512",
                                                                      }}
                                                                      xmlSpace="preserve"
                                                                    >
                                                                      <g>
                                                                        <path
                                                                          d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                          fill={
                                                                            "#000"
                                                                          }
                                                                        />
                                                                      </g>
                                                                    </svg>
                                                                    <span
                                                                      className="text-primary"
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        marginLeft:
                                                                          "5px",
                                                                      }}
                                                                    >
                                                                      {msg
                                                                        ?.files_path
                                                                        ?.length ===
                                                                      1
                                                                        ? "1 document"
                                                                        : `${msg?.files_path?.length} documents`}
                                                                    </span>
                                                                  </span>
                                                                </div>
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                        </div>
                                                        <Collapse
                                                          in={
                                                            expanded[msgIndex]
                                                          }
                                                          style={{
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          <ol
                                                            style={{
                                                              marginBottom:
                                                                "0rem",
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            {msg?.files_path?.map(
                                                              (
                                                                file,
                                                                fileIndex
                                                              ) => (
                                                                <li
                                                                  key={
                                                                    fileIndex
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      textDecoration:
                                                                        "underline",
                                                                    }}
                                                                    onClick={() => {
                                                                      viewFiles(
                                                                        file
                                                                      );
                                                                    }}
                                                                  >
                                                                    <i>
                                                                      {file
                                                                        .split(
                                                                          "/"
                                                                        )
                                                                        .pop()}
                                                                    </i>
                                                                  </span>
                                                                </li>
                                                              )
                                                            )}
                                                          </ol>
                                                        </Collapse>
                                                      </div>
                                                    )
                                                  )}

                                                  {request?.revised_amount !==
                                                    null && (
                                                    <div>
                                                      Amount:{" "}
                                                      {request?.revised_amount
                                                        .replace("$$", "$")
                                                        .replace(".00", "")}
                                                    </div>
                                                  )}
                                                  <div>
                                                    {request?.accepted_date
                                                      ? "Accepted date: "
                                                      : "Denied date: "}
                                                    {request?.accepted_date ||
                                                      request?.denied_date}
                                                  </div>
                                                  <div>
                                                    {
                                                      request?.accepted_denied_by
                                                    }{" "}
                                                    <strong>
                                                      {request?.accepted_date
                                                        ? "accepted"
                                                        : "denied"}
                                                    </strong>{" "}
                                                    the change request
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      ))}
                    </>
                  )}
                </div>
                <div
                  className=" d-flex justify-content-end"
                  style={{
                    background: "white",
                    position: "sticky",
                    padding: "10px 10px 10px 10px",
                    bottom: 0,
                    zIndex: 2,
                    borderTop: "1px solid lightgray",
                  }}
                >
                  {" "}
                  {individualMileStone === null && (
                    <Tooltip
                      title={
                        ContractChangeRequest.some(
                          (milestone) =>
                            milestone.temp_notification === "CR saved"
                        ) &&
                        ContractChangeRequest.every(
                          (milestone) =>
                            milestone.temp_notification === "CR saved" ||
                            (milestone.cr_notification === "CR raised" &&
                              milestone.temp_notification === "CR saved") ||
                            (milestone.temp_notification === "" &&
                              milestone.cr_notification === "")
                        )
                          ? ""
                          : ContractChangeRequest.every(
                              (milestone) =>
                                milestone.temp_notification === "" &&
                                milestone.cr_notification === ""
                            )
                          ? "Submit a Change Request"
                          : "Review and respond to all change requests raised by the Owner"
                      }
                    >
                      <div>
                        <button
                          className="btn detail-btn me-2 bg-danger text-white"
                          onClick={() => {
                            setEditmilestone(false);
                            Reuploadfeedback();

                            setEditIndex(null);
                          }}
                          style={{ fontSize: "14px" }}
                          // disabled={disabled === "enable"}
                          disabled={
                            !(
                              ContractChangeRequest.some(
                                (milestone) =>
                                  milestone.temp_notification === "CR saved"
                              ) &&
                              ContractChangeRequest.every(
                                (milestone) =>
                                  milestone.temp_notification === "CR saved" ||
                                  (milestone.cr_notification === "CR raised" &&
                                    milestone.temp_notification ===
                                      "CR saved") ||
                                  (milestone.temp_notification === "" &&
                                    milestone.cr_notification === "")
                              )
                            )
                            // false
                          }
                        >
                          Submit Change Request(s) to Owner
                        </button>
                      </div>
                    </Tooltip>
                  )}
                  {individualMileStone !== null &&
                    individualMileStone?.row?.status === "CR Phase" && (
                      <div>
                        <button
                          className="btn bg-danger text-white me-3"
                          onClick={() => {
                            cancelCRRequest();
                          }}
                          // disabled={disabled === "disable"}
                          style={{ fontSize: "14px" }}
                        >
                          CR Deny
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={Reuploadcontract}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Reupload}>
          <div
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "white",
              zIndex: 1,
              padding: "10px 20px 5px 20px",
              borderBottom: "1px solid lightgray",
            }}
          >
            <div className="mt-1">
              <div className="d-flex justify-content-between">
                <div>
                  <h5>
                    Revised Contract Approval
                    <span className="text-danger  fs-4">*</span>
                  </h5>
                </div>
                <div className="d-flex">
                  <button
                    className="btn detail-btn ms-auto  me-2"
                    onClick={() => {
                      setChangeContract(false);
                      setSelectedPdf(null);
                      setTextAreaValues([]);
                      setEnableTextarea(
                        Array(ContractChangeRequest.length).fill(false)
                      );
                      setEditmilestone(false);
                      setReUplodacontract(false);

                      setReuploadSelectedPdf(null);
                      setAImessage(false);
                      setGenAI(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-cvault"
                    onClick={() => {
                      Acceptproject();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-1 ">
            <div>
              <div className="drag-area  px-5 mt-3" style={{ margin: 0 }}>
                <label
                  htmlFor="pdfFile"
                  className="text-center m-auto bg-white w-50 cursor"
                >
                  <>
                    <div class="icon">
                      <i class="fas fa-cloud-upload-alt"></i>
                    </div>
                    <input
                      type="file"
                      id="pdfFile"
                      key={selectedPdf ? selectedPdf.name : "defaultKey"}
                      name="pdfFile"
                      accept=".pdf"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <>
                      <header> Upload Revised Contract</header>
                    </>
                  </>
                </label>
              </div>
              <div className="d-flex justify-content-between">
                {" "}
                <div>
                  {" "}
                  {selectedPdf && (
                    <p className="m-auto mt-3">
                      Uploaded Contract:
                      <span className="text-danger"> {filename}</span>
                    </p>
                  )}
                </div>
                <div>
                  {" "}
                  {selectedPdf && (
                    <div className=" d-flex mt-3">
                      <label for="budget w-100">
                        {" "}
                        Project Budget
                        <span className="text-danger fs-4">*</span>{" "}
                      </label>
                      <TextField
                        inputRef={projectBudgetRef}
                        style={{
                          border: "1px solid lightgray",
                          borderBottom: "0px !important",
                          outline: "none",
                          width: "60%",
                        }}
                        className="budgetinput form-control mt-1"
                        value={state.project_budget}
                        onChange={handleChange}
                        name="project_budget"
                        id="formatted-numberformat-input"
                        placeholder="Project Budget"
                        InputProps={{
                          inputComponent: NumericFormatCustom,
                        }}
                        variant="standard"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="row  custom-row">
                <div className="col-md-6  mt-3">
                  {reuplodaselectedPdf && (
                    <iframe
                      title="PDF Viewer"
                      style={iframeStyle}
                      src={reuplodaselectedPdf}
                    />
                  )}
                </div>
                <div
                  className={
                    selectedPdf !== null ? "col-md-6 mt-3" : "col-md-12 mt-3"
                  }
                  style={{ display: selectedPdf !== null ? "" : "none" }}
                >
                  <span className="mt-2 fs-4">Milestone(s)</span>
                  {inputList.map((x, i) => (
                    <div className="box" key={i}>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex">
                          {" "}
                          <p className="mt-2">{i + 1}</p>
                          <span className="mt-2">:</span>
                          <input
                            value={x.Milestone}
                            onChange={(e) => handleInputChanges(e, i)}
                            name="Milestone"
                            placeholder="Milestone Name"
                            className="ms-1 mt-1"
                            style={{
                              height: "38px",
                              width: "auto",
                              borderRadius: "6px",
                            }}
                          />
                        </div>
                        <div className="d-flex">
                          <label className="me-2 mt-2">Amount</label>
                          <TextField
                            style={{
                              border: "1px solid lightgray",
                              borderBottom: "0px !important",
                              outline: "none",
                              height: "34px",
                            }}
                            className="budgetinput form-control mt-1"
                            value={x.price}
                            onChange={(e) => {
                              handleInputChanges(e, i);
                            }}
                            name="price"
                            id="formatted-numberformat-input"
                            // placeholder="Project Budget"
                            InputProps={{
                              inputComponent: NumericFormatCustom,
                            }}
                            variant="standard"
                          />
                        </div>
                      </div>
                      <textarea
                        name="description"
                        className="mt-2 ms-3"
                        style={{
                          height: "100px",
                          width: "98%",
                          borderRadius: "6px",
                        }}
                        placeholder="Description"
                        value={x.description}
                        onChange={(e) => handleInputChanges(e, i)}
                      />
                      <div className="btn-box">
                        {inputList.length !== 1 && (
                          <button
                            className="mr10 btn detail-btn ms-3"
                            onClick={() => handleRemoveClick(i)}
                          >
                            Remove
                          </button>
                        )}
                        {individualMileStone === null &&
                          inputList.length - 1 === i && (
                            <button
                              className="btn btn-cvault ms-2"
                              onClick={handleAddClick}
                            >
                              Add
                            </button>
                          )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={ownerinformation}
        onClose={() => setownerInformation(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modelStyleowner}>
          {selectedOwner ? (
            <div>
              <div className="d-flex justify-content-between">
                <h4>Owner Information</h4>
                <IoMdClose
                  className="fs-4 cursor"
                  onClick={() => {
                    setownerInformation(false);
                  }}
                />
              </div>
              <div className="card-body ownerinfo">
                <div className="row d-flex">
                  <div className="col-md-3">
                    <b>Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.owner_name}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Co-Owner Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.co_owner_name || "---"}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Phone</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.contact_info}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Email</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.email}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </Modal>

      <Modal
        open={ContractPdf}
        onClose={() => {
          setContractPdf(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            // maxHeight: "100vh", // Ensure the modal does not exceed viewport height
            overflowY: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <div>
                <h5>Project Contract</h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractPdf(false);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedPdfFile && (
                <iframe
                  title="PDF Viewer"
                  style={iframeStyleContractPdf}
                  src={selectedPdfFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>

      <Drawer
        variant="temporary"
        anchor="right" // Drawer on Right Side
        open={ProjectLevelViewModal}
        onClose={() => {
          setProjectLevelViewModal(false);
          setProjectLevelContractorFiles([]);
          setShowDocuments(null);
          setFileError("");
        }}
        sx={{
          width: "50%",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "50%",
            boxSizing: "border-box",
          },
        }}
      >
        <Box sx={{ padding: "10px" }}>
          <div>
            <div className="d-flex justify-content-between mt-1">
              <h4> {docHeader}</h4>{" "}
              <IoMdClose
                className="fs-4 cursor"
                onClick={() => {
                  setProjectLevelViewModal(false);
                  setProjectLevelContractorFiles([]);
                  setShowDocuments(null);
                  setFileError("");
                }}
              />
            </div>
            <div className="dropdown-divider"></div>

            {projectLevelContractorFiles?.length !== 0 ? (
              <>
                <div
                  className="grid-container"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
                    gap: "0px",
                    padding: "2px",
                    overflowX: "auto",
                  }}
                >
                  {projectLevelContractorFiles?.map((item, index) => (
                    <div
                      key={index}
                      className="preview-item group relative text-sm text-token-text-primary view_files"
                      style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        background: "#fff",
                        borderRadius: "2px",
                        marginTop: "0px",
                      }}
                    >
                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-xl view_files">
                        <div style={{ textAlign: "center" }}>
                          <Tooltip
                            placement="top"
                            title={`Click to view document`}
                            // title={`Click to view ${item.split("/").pop()}`}
                          >
                            <div
                              style={{ cursor: "pointer" }}
                              className="grid-item"
                              onClick={() => viewFiles(item, true)}
                            >
                              <TextSnippetIcon
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  color: "rgb(128 175 215)",
                                  opacity: "0.9",
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div>
                        {/* File Name */}
                        <div
                          style={{
                            color: "gray",
                            fontSize: "12px",
                            marginTop: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => viewFiles(item, true)}
                        >
                          {(() => {
                            const fileName = item.split("/").pop(); // Extract filename from path
                            if (fileName.length > 9) {
                              return (
                                fileName.replace(/ /g, "").slice(0, 4) +
                                "..." +
                                fileName.replace(/ /g, "").slice(-4)
                              );
                            }
                            return fileName.replace(/ /g, "");
                          })()}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {isLoader && (
                  <div className="mt-2">
                    <div
                      className="text-center mb-3"
                      style={{ fontSize: "13px", color: "#F5AE41" }}
                    >
                      Fetching document from cloud storage. Please wait...
                    </div>

                    <BarLoader
                      color="#F5AE41"
                      width={"80%"}
                      height={5}
                      className="loader"
                      loading={isLoader}
                    />
                  </div>
                )}
                {showDocuments && (
                  <div
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <label className="mb-2" style={{ fontSize: "14px" }}>
                      Selected Document :{" "}
                      <span className="text-primary">
                        {showDocuments.file_name}
                      </span>
                    </label>

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                        showDocuments.file_name
                      ) && (
                        // <img
                        //   src={showDocuments.base64_content}
                        //   style={{
                        //     width: "100%",
                        //     height: "100%",
                        //     objectFit: "cover",
                        //   }}
                        //   alt={showDocuments.file_name}
                        // />
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                    {typeof showDocuments.base64_content === "string" &&
                      /\.(pdf)$/i.test(showDocuments.file_name) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                    {typeof showDocuments.base64_content === "string" &&
                      /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                        showDocuments.file_name
                      ) && (
                        <video
                          style={{ width: "100%", height: "60vh" }}
                          controls
                          src={showDocuments.base64_content}
                        ></video>
                      )}
                  </div>
                )}
                {fileError !== "" && (
                  <div className="text-danger text-center">{fileError}</div>
                )}
              </>
            ) : (
              <div className="text-center mt-4">
                <div
                  style={{
                    background: "aliceblue",
                    width: "max-content",
                    margin: "auto",
                    padding: "20px",
                    borderRadius: "50%",
                  }}
                >
                  <TextSnippetIcon
                    style={{
                      width: "70px",
                      height: "70px",
                      color: "rgb(128 175 215)",
                      opacity: "0.9",
                    }}
                  />
                </div>
                <p className="mt-2" style={{ fontSize: "14px" }}>
                  {" "}
                  No documents have been attached
                </p>
              </div>
            )}
          </div>
        </Box>
      </Drawer>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center", // Center vertically
          horizontal: "left", // Align to the right side
        }}
        transformOrigin={{
          vertical: "center", // Center vertically
          horizontal: "right", // Align to the left side
        }}
        style={{ borderRadius: "5px", marginLeft: "-1%" }}
      >
        <Typography style={popoverStyle}>
          <div className="text-center  d-flex justify-content-center h-100 align-items-center ">
            <div>
              <p className="fw-bold fs-6">Milestone(s) Recap</p>
              {Object.entries(count || {}).map(([key, value]) => {
                const spacing =
                  key === "Inspection Phase"
                    ? "22px"
                    : key === "Completed"
                    ? "64px"
                    : "60px";

                return (
                  <span className="admininspection" key={key}>
                    {key}
                    <span style={{ marginLeft: spacing }} />
                    {value}
                  </span>
                );
              })}
            </div>
          </div>
        </Typography>
      </Popover>
      <style>
        {`
        //   .container { text-align: center; }
          .file-upload { margin-bottom: 20px; }
          .upload-btn { padding: 10px 20px; background: #007bff; color: white; cursor: pointer; border-radius: 5px; }
          .preview-container { display: flex; flex-wrap: wrap; gap: 10px; }
          .preview-item { position: relative; text-align: center;margin-top: 5px; }
          .file-name { font-size: 14px; margin-bottom: 5px; color: #333; }
          .preview-img, .preview-video, .preview-pdf { width: 60px; height: 60px; object-fit: fill; border-radius: 5px; }
          .preview-imgs, .preview-videos, .preview-pdfs { width: 100%; height: 100px; object-fit: cover; border-radius: 5px; }
          .delete-btn { position: absolute; top: -5px; right: -5px; background: darkgray; color: white; border: none; cursor: pointer; border-radius: 50%;font-size:10px  }
        `}
      </style>

      {/* Modal for File View */}

      <Modal
        open={ContractDocuments}
        onClose={() => {
          setContractDocuments(false);
          setSelectedContractDoc(null); // Reset selected document on close
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <h5>Uploaded Document</h5>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractDocuments(false);
                  setSelectedContractDoc(null);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedContractDoc && (
                <>
                  <iframe
                    title="PDF Viewer"
                    style={{
                      width: "100%",
                      height: "85vh",
                      border: "none",
                      objectFit: "contain",
                    }}
                    src={selectedContractDoc}
                  />
                </>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default ContractorHome;
